import { useState, useEffect, useCallback, useRef } from "react";
import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth";
import { collection, doc, setDoc, getDoc, getDocs, deleteDoc } from "firebase/firestore";
import { auth, db } from "./firebase";

// ── EmailJS config — popuni ova 3 podatka sa emailjs.com ──
const EJS_SERVICE  = "service_jdbgovf";
const EJS_TEMPLATE = "template_f3k9f85";
const EJS_KEY      = "sHRIOzecybawz6xuo";

async function sendWelcomeEmail({toEmail, naziv, status, istice, regLink}){
  if(EJS_SERVICE==="YOUR_SERVICE_ID") return; // nije konfigurisan
  try{
    const ime = naziv ? naziv.split(" ")[0] : "";
    const isTrial = status === "trial";
    const payload = {
      service_id:  EJS_SERVICE,
      template_id: EJS_TEMPLATE,
      user_id:     EJS_KEY,
      template_params: {
        to_email:   toEmail,
        to_name:    ime || toEmail,
        reg_link:   regLink,
        tip:        isTrial ? "Trial 7 dana" : "Aktivna pretplata",
        istice:     istice ? new Date(istice).toLocaleDateString("bs-BA") : "",
        from_name:  "IPTV Manager",
      }
    };
    const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body: JSON.stringify(payload)
    });
    return res.status === 200;
  }catch(e){
    console.error("EmailJS error:", e);
    return false;
  }
}

// ── Utils ──────────────────────────────────────────────────
const addMonths=(ds,m)=>{const d=new Date(ds);d.setMonth(d.getMonth()+parseInt(m));return d.toISOString().split("T")[0];};
const addDays=(ds,d)=>{const dt=new Date(ds);dt.setDate(dt.getDate()+d);return dt.toISOString().split("T")[0];};
const today=()=>new Date().toISOString().split("T")[0];
const daysLeft=e=>Math.ceil((new Date(e)-new Date())/86400000);
const fmtDate=d=>d?new Date(d).toLocaleDateString("bs-BA"):"—";
const fmtKM=v=>`${parseFloat(v||0).toFixed(2)} KM`;
const uid=()=>Date.now().toString(36)+Math.random().toString(36).slice(2);
const emailToKey=e=>e.toLowerCase().trim().replace(/\.+/g,"_").replace(/@/g,"__AT__");
const isMobile=()=>window.innerWidth<700;
const ADMIN_EMAIL="antigonson@gmail.com"; //

const STATUS=e=>{const d=daysLeft(e);if(d<0)return{label:"Isteklo",color:"#f87171",bg:"#1f0d0d",border:"#7f1d1d"};if(d<=7)return{label:`${d}d`,color:"#fbbf24",bg:"#1c1300",border:"#78350f"};return{label:"Aktivan",color:"#4ade80",bg:"#0d2318",border:"#166534"};};
const PAY=s=>{if(s==="gratis")return{label:"Gratis",color:"#a78bfa",bg:"#1e1a35"};if(s==="placeno")return{label:"Plaćeno",color:"#4ade80",bg:"#0d2318"};return{label:"Nije plaćeno",color:"#f87171",bg:"#1f0d0d"};};
const LICENCE=s=>{
  if(s==="trial")return{label:"Trial",color:"#fbbf24",bg:"#1c1300",border:"#78350f"};
  if(s==="active")return{label:"Aktivan",color:"#4ade80",bg:"#0d2318",border:"#166534"};
  if(s==="expired")return{label:"Isteklo",color:"#f87171",bg:"#1f0d0d",border:"#7f1d1d"};
  return{label:"Blokiran",color:"#f87171",bg:"#1f0d0d",border:"#7f1d1d"};
};

const C={bg:"#080b12",panel:"#0f1420",card:"#131929",border:"#1e2538",text:"#e2e8f0",muted:"#64748b",accent:"#38bdf8",adim:"#0c2d3f",purple:"#a78bfa",pdim:"#1e1a35",green:"#4ade80",red:"#f87171",yellow:"#fbbf24",orange:"#fb923c"};
const IS={width:"100%",background:C.bg,border:`1px solid ${C.border}`,borderRadius:10,padding:"10px 14px",color:C.text,fontSize:14,outline:"none",boxSizing:"border-box",WebkitAppearance:"none"};
const LS={display:"block",fontSize:11,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:0.8};
const BP={width:"100%",padding:"13px",borderRadius:12,border:"none",background:"linear-gradient(135deg,#0ea5e9,#6366f1)",color:"#fff",fontWeight:700,fontSize:15,cursor:"pointer"};

// ── Shared UI ──────────────────────────────────────────────
function FR({label,children}){return <div style={{marginBottom:16}}><label style={LS}>{label}</label>{children}</div>;}
function T3({label,value,onChange,opts}){return(<div style={{marginBottom:16}}><label style={LS}>{label}</label><div style={{display:"flex",gap:8}}>{opts.map(o=><button key={o.v} onClick={()=>onChange(o.v)} style={{flex:1,padding:"9px 4px",borderRadius:10,border:`1.5px solid ${value===o.v?o.c:C.border}`,background:value===o.v?`${o.c}18`:C.bg,color:value===o.v?o.c:C.muted,fontSize:12,fontWeight:600,cursor:"pointer"}}>{o.l}</button>)}</div></div>);}
function Stat({label,value,icon,color,bg,small}){return(<div style={{background:bg||C.card,border:`1px solid ${color}22`,borderRadius:14,padding:small?"12px 14px":"16px 18px"}}><div style={{fontSize:small?18:22,marginBottom:6}}>{icon}</div><div style={{fontSize:small?18:24,fontWeight:800,color,fontVariantNumeric:"tabular-nums"}}>{value}</div><div style={{fontSize:11,color:C.muted,marginTop:3}}>{label}</div></div>);}
function Toast({t}){if(!t)return null;const m={ok:[C.green,"#0d2318","#166534"],err:[C.red,"#1f0d0d","#7f1d1d"],warn:[C.yellow,"#1c1300","#78350f"]};const[c,bg,b]=m[t.type]||m.ok;return<div style={{position:"fixed",bottom:isMobile()?80:28,left:"50%",transform:"translateX(-50%)",background:bg,color:c,border:`1px solid ${b}`,padding:"12px 24px",borderRadius:12,fontSize:14,fontWeight:500,zIndex:9999,boxShadow:"0 8px 32px rgba(0,0,0,0.6)",whiteSpace:"nowrap",maxWidth:"90vw",textAlign:"center"}}>{t.msg}</div>;}
function Loader(){return<div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{textAlign:"center"}}><div style={{width:44,height:44,border:`3px solid ${C.border}`,borderTop:`3px solid ${C.accent}`,borderRadius:"50%",animation:"spin 0.8s linear infinite",margin:"0 auto 16px"}}/><div style={{color:C.muted,fontSize:14}}>Učitavanje...</div></div><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>;}

function Modal({title,onClose,children}){
  const mob=isMobile();
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:mob?"flex-end":"center",justifyContent:"center",zIndex:400,padding:mob?"0":"16px"}} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={{background:C.panel,borderRadius:mob?"20px 20px 0 0":"18px",padding:mob?"20px 20px 32px":"28px",width:"100%",maxWidth:mob?600:480,maxHeight:"92vh",overflowY:"auto"}}>
        {mob&&<div style={{width:40,height:4,background:C.border,borderRadius:2,margin:"0 auto 18px"}}/>}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{fontWeight:800,fontSize:17}}>{title}</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:24,padding:"0 4px",lineHeight:1}}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function CsvBtn({label,rows}){
  const go=()=>{
    const csv=rows.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(";")).join("\n");
    const a=document.createElement("a");
    a.href=URL.createObjectURL(new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8"}));
    a.download=`export_${today()}.csv`;a.click();
  };
  return <button onClick={go} style={{padding:"9px 16px",borderRadius:9,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:12,cursor:"pointer",whiteSpace:"nowrap"}}>⬇️ {label}</button>;
}

// ══ PDF KARTICA ═══════════════════════════════════════════
function genPDF(u){
  const fmtD=d=>d?new Date(d).toLocaleDateString("bs-BA"):"—";
  const fmtK=v=>`${parseFloat(v||0).toFixed(2)} KM`;
  const PAYl=s=>s==="gratis"?"Gratis":s==="placeno"?"Placeno":"Nije placeno";
  const uplateH=(u.historija||[]).filter(h=>h.payStatus==="placeno"&&h.cijenaKM>0);
  const ukupno=uplateH.reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  const dug=(u.historija||[]).filter(h=>h.payStatus==="nije_placeno").reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Kartica — ${u.ime}</title>
  <style>*{margin:0;padding:0;box-sizing:border-box;}body{font-family:Arial,sans-serif;font-size:13px;color:#111;padding:32px;max-width:700px;margin:0 auto;}.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:28px;padding-bottom:16px;border-bottom:2px solid #0ea5e9;}.logo{font-size:22px;font-weight:800;color:#0ea5e9;}.logo span{color:#6366f1;}.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:24px;}.info-box{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px 16px;}.info-label{font-size:10px;text-transform:uppercase;letter-spacing:0.8px;color:#888;margin-bottom:4px;}.info-val{font-weight:700;font-size:14px;}.aktivan{color:#16a34a;}.isteklo{color:#dc2626;}.uskoro{color:#d97706;}.placeno{color:#16a34a;}.nije{color:#dc2626;}.gratis{color:#7c3aed;}table{width:100%;border-collapse:collapse;margin-bottom:20px;}th{background:#0ea5e9;color:#fff;padding:9px 12px;text-align:left;font-size:11px;text-transform:uppercase;letter-spacing:0.6px;}td{padding:9px 12px;border-bottom:1px solid #e2e8f0;font-size:12px;}tr:nth-child(even) td{background:#f8fafc;}.total-row td{font-weight:800;background:#f0f9ff;border-top:2px solid #0ea5e9;font-size:13px;}.sum-box{display:flex;justify-content:space-between;background:#f0f9ff;border:2px solid #0ea5e9;border-radius:10px;padding:16px 20px;margin-bottom:20px;}.sum-item{text-align:center;}.sum-label{font-size:10px;text-transform:uppercase;letter-spacing:0.8px;color:#666;margin-bottom:4px;}.sum-val{font-size:18px;font-weight:800;}.footer{text-align:center;color:#999;font-size:10px;padding-top:16px;border-top:1px solid #e2e8f0;margin-top:8px;}@media print{body{padding:16px;}}</style></head><body>
  <div class="header"><div><div class="logo">📡 IPTV <span>Manager</span></div><div style="font-size:11px;color:#666;margin-top:3px">Kartica pretplatnika</div></div><div style="text-align:right"><div style="font-size:11px;color:#666">Datum ispisa:</div><div style="font-weight:700">${fmtD(new Date().toISOString().split("T")[0])}</div></div></div>
  <h2 style="font-size:18px;font-weight:800;margin-bottom:4px">${u.ime}</h2>
  <div style="color:#666;font-size:12px;margin-bottom:20px">${u.telefon||"Bez broja"}${u.vivo?" · Vivo Player":""}</div>
  <div class="info-grid">
    <div class="info-box"><div class="info-label">Status pretplate</div><div class="info-val ${(()=>{const d=Math.ceil((new Date(u.expiry)-new Date())/86400000);return d<0?"isteklo":d<=7?"uskoro":"aktivan";})()}">${(()=>{const d=Math.ceil((new Date(u.expiry)-new Date())/86400000);return d<0?"Isteklo":d<=7?`Istice za ${d} dana`:"Aktivan";})()}</div></div>
    <div class="info-box"><div class="info-label">Istek pretplate</div><div class="info-val">${fmtD(u.expiry)}</div></div>
    <div class="info-box"><div class="info-label">Status uplate</div><div class="info-val ${u.payStatus==="placeno"?"placeno":u.payStatus==="gratis"?"gratis":"nije"}">${PAYl(u.payStatus)}</div></div>
    <div class="info-box"><div class="info-label">Korisnik od</div><div class="info-val">${fmtD(u.kreiran)}</div></div>
  </div>
  <div class="sum-box">
    <div class="sum-item"><div class="sum-label">Ukupno uplaceno</div><div class="sum-val" style="color:#16a34a">${fmtK(ukupno)}</div></div>
    <div class="sum-item"><div class="sum-label">Broj uplata</div><div class="sum-val" style="color:#0ea5e9">${uplateH.length}</div></div>
    ${dug>0?`<div class="sum-item"><div class="sum-label">Dugovanje</div><div class="sum-val" style="color:#dc2626">${fmtK(dug)}</div></div>`:""}
  </div>
  <table><thead><tr><th>#</th><th>Datum</th><th>Opis</th><th>Mj.</th><th>Status</th><th>Uplata</th></tr></thead><tbody>
  ${(u.historija||[]).map((h,i)=>`<tr><td>${i+1}</td><td>${h.datum||"—"}</td><td>${h.tip==="novi"?"Aktivacija":h.tip==="import"?"Import":h.tip==="uplata"?"Promjena statusa":"Produzenje"}</td><td>${h.mjeseci||"—"}</td><td class="${h.payStatus==="placeno"?"placeno":h.payStatus==="gratis"?"gratis":"nije"}">${PAYl(h.payStatus)}</td><td style="font-weight:700">${h.payStatus==="gratis"?"—":fmtK(h.cijenaKM||0)}</td></tr>`).join("")}
  <tr class="total-row"><td colspan="5" style="text-align:right">UKUPNO UPLACENO:</td><td>${fmtK(ukupno)}</td></tr>
  </tbody></table>
  <div class="footer">IPTV Manager · Generisano ${new Date().toLocaleString("bs-BA")}</div>
  </body></html>`;
  const w=window.open("","_blank","width=800,height=900");
  w.document.write(html);w.document.close();w.focus();
  setTimeout(()=>w.print(),600);
}

// ══ TRIAL EXPIRED SCREEN ══════════════════════════════════
function TrialExpiredPage({licence,onSignOut}){
  const isTrial=licence?.status==="trial";
  const dl=isTrial?daysLeft(licence.istice):0;
  return(
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',system-ui,sans-serif",padding:24}}>
      <div style={{maxWidth:440,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:56,marginBottom:16}}>{isTrial&&dl>0?"⏳":"🔒"}</div>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:22,fontWeight:800,marginBottom:10}}>
          {isTrial&&dl>0?"Trial period aktivan":"Pretplata istekla"}
        </div>
        {isTrial&&dl>0?(
          <div style={{color:C.muted,fontSize:14,marginBottom:24}}>Imaš još <span style={{color:C.yellow,fontWeight:700}}>{dl} dana</span> trial perioda.<br/>Kontaktiraj admina za aktivaciju.</div>
        ):(
          <div style={{color:C.muted,fontSize:14,marginBottom:24}}>Tvoja pretplata je istekla.<br/>Kontaktiraj admina za obnovu pristupa.</div>
        )}
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"18px 20px",marginBottom:20,textAlign:"left"}}>
          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.8,marginBottom:10}}>Kontakt</div>
          <div style={{fontSize:14,color:C.text}}>📧 {ADMIN_EMAIL}</div>
        </div>
        <button onClick={onSignOut} style={{...BP,background:"transparent",border:`1px solid ${C.border}`,color:C.muted}}>🚪 Odjavi se</button>
      </div>
    </div>
  );
}

// ══ MAIN APP ══════════════════════════════════════════════
export default function App(){
  const [user,setUser]=useState(undefined);
  const [licence,setLicence]=useState(null);
  const [licenceLoading,setLicenceLoading]=useState(false);
  const [page,setPage]=useState("dashboard");
  const [users,setUsers]=useState([]);
  const [credits,setCredits]=useState(0);
  const [crHist,setCrHist]=useState([]);
  const [toast,setToast]=useState(null);
  const [modal,setModal]=useState(null);
  const [activeUser,setActiveUser]=useState(null);
  const [loading,setLoading]=useState(false);
  const [mob,setMob]=useState(isMobile());

  useEffect(()=>{const h=()=>setMob(isMobile());window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);
  const showToast=(msg,type="ok")=>{setToast({msg,type});setTimeout(()=>setToast(null),3200);};

  useEffect(()=>{const u=onAuthStateChanged(auth,u=>setUser(u||null));return u;},[]);

  // Load licence for non-admin users
  useEffect(()=>{
    if(!user||user.email===ADMIN_EMAIL){setLicence(null);return;}
    setLicenceLoading(true);
    const emailKey=emailToKey(user.email);
    getDoc(doc(db,"dozvoljeni",emailKey)).then(d=>{
      if(d.exists()) setLicence(d.data());
      else setLicence({status:"blocked"});
      setLicenceLoading(false);
    }).catch(()=>{setLicence({status:"blocked"});setLicenceLoading(false);});
  },[user]);

  const loadData=useCallback(async()=>{
    if(!user)return;
    setLoading(true);
    const isAdmin=user.email===ADMIN_EMAIL;
    const emailKey=emailToKey(user.email);
    const prefix=isAdmin?"meta":"tenant_"+emailKey;
    try{
      if(isAdmin){
        const cd=await getDoc(doc(db,"meta","credits"));setCredits(cd.exists()?cd.data().value:0);
        const ch=await getDoc(doc(db,"meta","creditHistory"));setCrHist(ch.exists()?ch.data().list:[]);
        const snap=await getDocs(collection(db,"korisnici"));
        const list=[];snap.forEach(d=>list.push({id:d.id,...d.data()}));
        setUsers(list.sort((a,b)=>a.ime.localeCompare(b.ime)));
      }else{
        const cd=await getDoc(doc(db,"tenants",emailKey,"meta","credits"));setCredits(cd.exists()?cd.data().value:0);
        const ch=await getDoc(doc(db,"tenants",emailKey,"meta","creditHistory"));setCrHist(ch.exists()?ch.data().list:[]);
        const snap=await getDocs(collection(db,"tenants",emailKey,"korisnici"));
        const list=[];snap.forEach(d=>list.push({id:d.id,...d.data()}));
        setUsers(list.sort((a,b)=>a.ime.localeCompare(b.ime)));
      }
    }catch(e){showToast("Greška učitavanja","err");}
    setLoading(false);
  },[user]);

  useEffect(()=>{
    if(!user)return;
    if(user.email===ADMIN_EMAIL){loadData();return;}
    if(licence&&(licence.status==="active"||(licence.status==="trial"&&daysLeft(licence.istice)>0)))loadData();
  },[user,licence,loadData]);

  const isAdmin=user?.email===ADMIN_EMAIL;
  const emailKey=user?.email?emailToKey(user.email):"";

  const saveCredits=async(v)=>{
    setCredits(v);
    if(isAdmin)await setDoc(doc(db,"meta","credits"),{value:v});
    else await setDoc(doc(db,"tenants",emailKey,"meta","credits"),{value:v});
  };
  const saveCrHist=async(v)=>{
    setCrHist(v);
    if(isAdmin)await setDoc(doc(db,"meta","creditHistory"),{list:v});
    else await setDoc(doc(db,"tenants",emailKey,"meta","creditHistory"),{list:v});
  };
  const saveUser=async(u)=>{
    const ref=isAdmin?doc(db,"korisnici",u.id):doc(db,"tenants",emailKey,"korisnici",u.id);
    await setDoc(ref,u);
    setUsers(p=>{const i=p.findIndex(x=>x.id===u.id);if(i>=0){const n=[...p];n[i]=u;return n;}return [...p,u].sort((a,b)=>a.ime.localeCompare(b.ime));});
  };
  const delUser=async(id)=>{
    const ref=isAdmin?doc(db,"korisnici",id):doc(db,"tenants",emailKey,"korisnici",id);
    await deleteDoc(ref);setUsers(p=>p.filter(x=>x.id!==id));
  };

  if(user===undefined||licenceLoading)return<Loader/>;
  if(!user)return<AuthPage showToast={showToast}/>;

  // Admin → prikaži admin panel
  if(isAdmin)return<AdminApp user={user} showToast={showToast} toast={toast} mob={mob} loading={loading} users={users} credits={credits} crHist={crHist} saveCredits={saveCredits} saveCrHist={saveCrHist} saveUser={saveUser} delUser={delUser} page={page} setPage={setPage} modal={modal} setModal={setModal} activeUser={activeUser} setActiveUser={setActiveUser}/>;

  // Provjera licence
  if(!licence||licence.status==="blocked")return<TrialExpiredPage licence={licence} onSignOut={()=>signOut(auth)}/>;
  if(licence.status==="trial"&&daysLeft(licence.istice)<=0)return<TrialExpiredPage licence={licence} onSignOut={()=>signOut(auth)}/>;
  if(licence.status==="expired")return<TrialExpiredPage licence={licence} onSignOut={()=>signOut(auth)}/>;

  return<TenantApp user={user} licence={licence} showToast={showToast} toast={toast} mob={mob} loading={loading} users={users} credits={credits} crHist={crHist} saveCredits={saveCredits} saveCrHist={saveCrHist} saveUser={saveUser} delUser={delUser} page={page} setPage={setPage} modal={modal} setModal={setModal} activeUser={activeUser} setActiveUser={setActiveUser}/>;
}

// ══ AUTH ══════════════════════════════════════════════════
function AuthPage({showToast}){
  const [mode,setMode]=useState(()=>window.location.search.includes("register")?"register":"login");
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [loading,setLoading]=useState(false);
  const [regDone,setRegDone]=useState(false);
  const [resetMode,setResetMode]=useState(false);
  const [resetSent,setResetSent]=useState(false);

  const handleReset=async()=>{
    if(!email.trim()){showToast("Unesite email adresu","err");return;}
    setLoading(true);
    try{
      await sendPasswordResetEmail(auth,email.trim());
      setResetSent(true);
    }catch(e){
      showToast("Greška: "+e.code,"err");
    }
    setLoading(false);
  };

  const handle=async()=>{
    if(!email||!pass){showToast("Unesite email i lozinku","err");return;}
    setLoading(true);
    try{
      if(mode==="login"){
        await signInWithEmailAndPassword(auth,email,pass);
      }else{
        const emailKey=emailToKey(email);
        const d=await getDoc(doc(db,"dozvoljeni",emailKey));
        if(!d.exists()){showToast("Email nije odobren. Kontaktirajte admina.","err");setLoading(false);return;}
        if(d.data().status==="blocked"){showToast("Pristup blokiran.","err");setLoading(false);return;}
        await createUserWithEmailAndPassword(auth,email,pass);
        // Označi da se registrirao
        try{
          const emailKey=emailToKey(email);
          await setDoc(doc(db,"dozvoljeni",emailKey),{registriran:today(),registriran_bool:true},{merge:true});
        }catch(e){console.warn("Could not mark registered:",e);}
        setRegDone(true);
      }
    }catch(e){
      const m=e.code==="auth/invalid-credential"||e.code==="auth/wrong-password"?"Pogrešan email ili lozinka":e.code==="auth/email-already-in-use"?"Email već korišten — probajte se prijaviti":e.code==="auth/weak-password"?"Lozinka mora imati min. 6 znakova":e.code==="auth/too-many-requests"?"Previše pokušaja. Pričekajte malo.":e.code==="auth/network-request-failed"?"Greška mreže. Provjerite internet.":"Greška: "+e.code;
      showToast(m,"err");
    }
    setLoading(false);
  };

  const BG={minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',system-ui,sans-serif",backgroundImage:"radial-gradient(ellipse at 20% 50%,#0c1a2e,transparent 60%),radial-gradient(ellipse at 80% 20%,#1a0c2e,transparent 50%)"};
  const LOGO=<div style={{textAlign:"center",marginBottom:36}}><div style={{width:64,height:64,borderRadius:18,background:"linear-gradient(135deg,#0ea5e9,#6366f1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,margin:"0 auto 14px",boxShadow:"0 0 48px rgba(14,165,233,0.35)"}}>📡</div><div style={{fontFamily:"'Syne',sans-serif",fontSize:26,fontWeight:800}}>IPTV Manager</div><div style={{color:C.muted,fontSize:14,marginTop:4}}>Upravljanje pretplatama</div></div>;

  // ── Registracija uspješna ──
  if(regDone) return(
    <div style={BG}><div style={{width:"100%",maxWidth:420,padding:"0 24px"}}>
      {LOGO}
      <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:20,padding:"32px 24px",textAlign:"center",boxShadow:"0 24px 64px rgba(0,0,0,0.5)"}}>
        <div style={{fontSize:56,marginBottom:16}}>🎉</div>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800,marginBottom:8}}>Registracija uspješna!</div>
        <div style={{color:C.muted,fontSize:14,marginBottom:24}}>Vaš račun je kreiran. Možete se prijaviti sa vašim emailom i lozinkom.</div>
        <button onClick={()=>{setRegDone(false);setMode("login");setPass("");}} style={BP}>🔐 Idi na prijavu</button>
      </div>
    </div></div>
  );

  // ── Reset lozinke ──
  if(resetMode) return(
    <div style={BG}><div style={{width:"100%",maxWidth:420,padding:"0 24px"}}>
      {LOGO}
      <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:20,padding:"28px 24px",boxShadow:"0 24px 64px rgba(0,0,0,0.5)"}}>
        {resetSent?(
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:48,marginBottom:14}}>📧</div>
            <div style={{fontFamily:"'Syne',sans-serif",fontSize:18,fontWeight:800,marginBottom:8}}>Email poslan!</div>
            <div style={{color:C.muted,fontSize:13,marginBottom:24}}>Provjerite inbox na <strong style={{color:C.text}}>{email}</strong> i kliknite link za reset lozinke.</div>
            <button onClick={()=>{setResetMode(false);setResetSent(false);}} style={BP}>← Natrag na prijavu</button>
          </div>
        ):(
          <>
            <div style={{fontFamily:"'Syne',sans-serif",fontSize:18,fontWeight:800,marginBottom:6}}>🔑 Zaboravili ste lozinku?</div>
            <div style={{color:C.muted,fontSize:13,marginBottom:20}}>Unesite vaš email i poslat ćemo link za reset.</div>
            <FR label="Email"><input id="reset-email" name="email" type="email" autoComplete="email" placeholder="vas@email.com" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleReset()} style={IS}/></FR>
            <button onClick={handleReset} disabled={loading} style={{...BP,marginBottom:12,opacity:loading?0.7:1}}>{loading?"Šaljem...":"📧 Pošalji reset link"}</button>
            <button onClick={()=>setResetMode(false)} style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:14,cursor:"pointer"}}>← Natrag</button>
          </>
        )}
      </div>
    </div></div>
  );

  // ── Login / Registracija ──
  return(
    <div style={BG}>
      <div style={{width:"100%",maxWidth:420,padding:"0 24px"}}>
        {LOGO}
        <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:20,padding:"28px 24px",boxShadow:"0 24px 64px rgba(0,0,0,0.5)"}}>
          <div style={{display:"flex",background:C.bg,borderRadius:10,padding:4,marginBottom:24}}>
            {[["login","Prijava"],["register","Registracija"]].map(([m,l])=><button key={m} onClick={()=>setMode(m)} style={{flex:1,padding:"9px",borderRadius:8,border:"none",cursor:"pointer",fontSize:13,fontWeight:600,background:mode===m?"linear-gradient(135deg,#0ea5e9,#6366f1)":"transparent",color:mode===m?"#fff":C.muted}}>{l}</button>)}
          </div>
          {mode==="register"&&<div style={{background:"#0c1a2e",border:`1px solid #0c3d5a`,borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:C.accent}}>ℹ️ Registracija je moguća samo za odobrene emailove.</div>}
          <FR label="Email"><input id="email" name="email" type="email" autoComplete="email" placeholder="vas@email.com" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()} style={IS}/></FR>
          <div style={{marginBottom:16}}><label style={LS}>Lozinka</label><input id="password" name="password" type="password" autoComplete={mode==="login"?"current-password":"new-password"} placeholder="••••••••" value={pass} onChange={e=>setPass(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()} style={IS}/></div>
          {mode==="login"&&<div style={{textAlign:"right",marginBottom:16}}><button onClick={()=>{setResetMode(true);}} style={{background:"none",border:"none",color:C.muted,fontSize:12,cursor:"pointer",textDecoration:"underline"}}>Zaboravili ste lozinku?</button></div>}
          <button onClick={handle} disabled={loading} style={{...BP,opacity:loading?0.7:1}}>{loading?"Molimo pričekajte...":mode==="login"?"Prijavi se":"Registriraj se"}</button>
        </div>
      </div>
    </div>
  );
}

// ══ ADMIN APP ═════════════════════════════════════════════
function AdminApp({user,showToast,toast,mob,loading,users,credits,crHist,saveCredits,saveCrHist,saveUser,delUser,page,setPage,modal,setModal,activeUser,setActiveUser}){
  const [kupci,setKupci]=useState([]);
  const [kupciLoading,setKupciLoading]=useState(false);
  const [adminPage,setAdminPage]=useState("mojIptv");

  const loadKupci=useCallback(async()=>{
    setKupciLoading(true);
    try{
      const snap=await getDocs(collection(db,"dozvoljeni"));
      const list=[];snap.forEach(d=>list.push({id:d.id,...d.data()}));
      setKupci(list.sort((a,b)=>(a.email||"").localeCompare(b.email||"")));
    }catch(e){showToast("Greška","err");}
    setKupciLoading(false);
  },[showToast]);

  useEffect(()=>{loadKupci();},[loadKupci]);

  const saveKupac=async(k)=>{
    const emailKey=emailToKey(k.email);
    console.log("saveKupac emailKey:", emailKey, "data:", k);
    try{
      await setDoc(doc(db,"dozvoljeni",emailKey),k);
      console.log("setDoc OK");
      setKupci(p=>{const i=p.findIndex(x=>x.id===emailKey);const nk={...k,id:emailKey};if(i>=0){const n=[...p];n[i]=nk;return n;}return [...p,nk].sort((a,b)=>(a.email||"").localeCompare(b.email||""));});
    }catch(e){
      console.error("saveKupac error:", e.code, e.message);
      throw e;
    }
  };
  const delKupac=async(id)=>{await deleteDoc(doc(db,"dozvoljeni",id));setKupci(p=>p.filter(x=>x.id!==id));};

  const adminNav=[{id:"kupci",icon:"👤",label:"Kupci"},{id:"mojIptv",icon:"📡",label:"Moj IPTV"}];
  const mobileAdminNav=[{id:"kupci",icon:"👤",label:"Kupci"},{id:"mojIptv",icon:"📡",label:"Moj IPTV"}];

  if(!mob) return(
    <div style={{minHeight:"100vh",background:C.bg,fontFamily:"'DM Sans',system-ui,sans-serif",color:C.text,display:"flex"}}>
      <div style={{width:230,background:C.panel,borderRight:`1px solid ${C.border}`,display:"flex",flexDirection:"column",position:"fixed",top:0,bottom:0,left:0,zIndex:50}}>
        <div style={{padding:"18px 12px 10px"}}>
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:18,fontWeight:800,marginBottom:10}}>📡 IPTV Admin</div>
          <div style={{display:"flex",background:C.bg,borderRadius:10,padding:3}}>
            <button onClick={()=>setAdminPage("kupci")} style={{flex:1,padding:"8px 4px",borderRadius:8,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,background:adminPage==="kupci"?"linear-gradient(135deg,#d97706,#92400e)":"transparent",color:adminPage==="kupci"?"#fff":C.muted}}>⚡ Admin</button>
            <button onClick={()=>setAdminPage("mojIptv")} style={{flex:1,padding:"8px 4px",borderRadius:8,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,background:adminPage==="mojIptv"?"linear-gradient(135deg,#0ea5e9,#6366f1)":"transparent",color:adminPage==="mojIptv"?"#fff":C.muted}}>📡 Moj IPTV</button>
          </div>
        </div>
        <nav style={{flex:1,padding:"0 8px",overflowY:"auto"}}>
          {adminPage==="kupci"&&[{id:"kupci",icon:"👤",label:"Kupci"},{id:"saas",icon:"💰",label:"Finansije"}].map(n=><button key={n.id} onClick={()=>setAdminPage(n.id)} style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,border:"none",cursor:"pointer",marginBottom:2,textAlign:"left",background:adminPage===n.id?"linear-gradient(135deg,#1c0f00,#1a0a00)":"transparent",color:adminPage===n.id?C.orange:C.muted,fontSize:13,fontWeight:adminPage===n.id?600:400,borderLeft:adminPage===n.id?`2px solid ${C.orange}`:"2px solid transparent"}}><span style={{fontSize:15}}>{n.icon}</span>{n.label}</button>)}
          {adminPage==="mojIptv"&&[{id:"dashboard",icon:"📊",label:"Dashboard"},{id:"dodaj",icon:"➕",label:"Dodaj korisnika"},{id:"import",icon:"📥",label:"Import CSV"},{id:"korisnici",icon:"👥",label:"Korisnici"},{id:"dugovanja",icon:"💸",label:"Dugovanja"},{id:"rekap",icon:"📋",label:"Rekapitulacija"},{id:"krediti",icon:"💳",label:"Krediti"}].map(n=><button key={n.id} onClick={()=>setPage(n.id)} style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,border:"none",cursor:"pointer",marginBottom:2,textAlign:"left",background:page===n.id?"linear-gradient(135deg,#0c2d3f,#1e1a35)":"transparent",color:page===n.id?C.text:C.muted,fontSize:13,fontWeight:page===n.id?600:400,borderLeft:page===n.id?`2px solid ${C.accent}`:"2px solid transparent"}}><span style={{fontSize:15}}>{n.icon}</span>{n.label}</button>)}
        </nav>
        <div style={{padding:"12px",borderTop:`1px solid ${C.border}`}}>
          <div style={{fontSize:11,color:C.muted,marginBottom:8,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user.email}</div>
          <button onClick={()=>signOut(auth)} style={{width:"100%",padding:"8px",borderRadius:9,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:12,cursor:"pointer"}}>🚪 Odjavi se</button>
        </div>
      </div>
      <div style={{marginLeft:230,flex:1,padding:"26px 32px"}}>
        {adminPage==="kupci"&&<KupciPage kupci={kupci} loading={kupciLoading} saveKupac={saveKupac} delKupac={delKupac} showToast={showToast}/>}
        {adminPage==="saas"&&<SaasPage kupci={kupci}/>}
        {adminPage==="mojIptv"&&<TenantContent mob={mob} loading={loading} users={users} credits={credits} crHist={crHist} saveCredits={saveCredits} saveCrHist={saveCrHist} saveUser={saveUser} delUser={delUser} page={page} setPage={setPage} modal={modal} setModal={setModal} activeUser={activeUser} setActiveUser={setActiveUser} showToast={showToast} isAdminView onSwitchAdmin={()=>setAdminPage("kupci")}/>}
      </div>
      <Toast t={toast}/>
    </div>
  );

  return(
    <div style={{minHeight:"100vh",background:C.bg,fontFamily:"'DM Sans',system-ui,sans-serif",color:C.text,paddingBottom:70}}>
      <div style={{maxWidth:600,margin:"0 auto"}}>
        {adminPage==="kupci"&&<KupciPage kupci={kupci} loading={kupciLoading} saveKupac={saveKupac} delKupac={delKupac} showToast={showToast}/>}
        {adminPage==="saas"&&<SaasPage kupci={kupci}/>}
        {adminPage==="mojIptv"&&<TenantContent mob={mob} loading={loading} users={users} credits={credits} crHist={crHist} saveCredits={saveCredits} saveCrHist={saveCrHist} saveUser={saveUser} delUser={delUser} page={page} setPage={setPage} modal={modal} setModal={setModal} activeUser={activeUser} setActiveUser={setActiveUser} showToast={showToast} isAdminView onSwitchAdmin={()=>setAdminPage("kupci")}/>}
      </div>
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:C.panel,borderTop:`1px solid ${C.border}`,zIndex:100,paddingBottom:"env(safe-area-inset-bottom)"}}>
        <div style={{display:"flex",background:C.bg,margin:"6px 10px 4px",borderRadius:12,padding:3}}>
          <button onClick={()=>setAdminPage("kupci")} style={{flex:1,padding:"9px 4px",borderRadius:10,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,background:adminPage==="kupci"?"linear-gradient(135deg,#d97706,#92400e)":"transparent",color:adminPage==="kupci"?"#fff":C.muted}}>⚡ Kupci</button>
          <button onClick={()=>setAdminPage("saas")} style={{flex:1,padding:"9px 4px",borderRadius:10,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,background:adminPage==="saas"?"linear-gradient(135deg,#16a34a,#14532d)":"transparent",color:adminPage==="saas"?"#fff":C.muted}}>💰 Finansije</button>
          <button onClick={()=>setAdminPage("mojIptv")} style={{flex:1,padding:"9px 4px",borderRadius:10,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,background:adminPage==="mojIptv"?"linear-gradient(135deg,#0ea5e9,#6366f1)":"transparent",color:adminPage==="mojIptv"?"#fff":C.muted}}>📡 Moj IPTV</button>
        </div>
        {adminPage==="mojIptv"&&<div style={{display:"flex",borderTop:`1px solid ${C.border}`}}>
          {[{id:"dashboard",icon:"📊",label:"Home"},{id:"korisnici",icon:"👥",label:"Korisnici"},{id:"dodaj",icon:"➕",label:"Dodaj"},{id:"dugovanja",icon:"💸",label:"Dugovi"},{id:"more",icon:"⋯",label:"Više"}].map(t=>(
            <button key={t.id} onClick={()=>setPage(t.id)} style={{flex:1,padding:"8px 4px 6px",border:"none",background:"transparent",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:1}}>
              <span style={{fontSize:17,lineHeight:1}}>{t.icon}</span>
              <span style={{fontSize:9,color:page===t.id?C.accent:C.muted,fontWeight:page===t.id?700:400}}>{t.label}</span>
              {page===t.id&&<div style={{width:12,height:2,background:C.accent,borderRadius:1}}/>}
            </button>
          ))}
        </div>}
      </div>
      <Toast t={toast}/>
    </div>
  );
}

// ══ SAAS FINANSIJE PAGE ══════════════════════════════════
function SaasPage({kupci}){
  const mob=isMobile();
  const MJES=["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"];

  const aktivni=kupci.filter(k=>k.status==="active"&&daysLeft(k.istice)>0);
  const trial=kupci.filter(k=>k.status==="trial"&&daysLeft(k.istice)>0);
  const istekli=kupci.filter(k=>daysLeft(k.istice)<=0);
  const uskoro=kupci.filter(k=>k.status==="active"&&daysLeft(k.istice)>0&&daysLeft(k.istice)<=7);

  // Mjesečna zarada od aktivnih (samo oni koji imaju cijenu)
  const mjZarada=aktivni.reduce((s,k)=>s+(parseFloat(k.cijena)||0),0);
  const godZarada=mjZarada*12;

  // Historija prihoda po mjesecima — koristimo kreiran datum
  const byMonth={};
  kupci.forEach(k=>{
    if(!k.kreiran)return;
    const ym=k.kreiran.slice(0,7);
    if(!byMonth[ym])byMonth[ym]={novi:0,prihod:0};
    byMonth[ym].novi++;
    byMonth[ym].prihod+=parseFloat(k.cijena)||0;
  });

  // Zadnjih 6 mjeseci
  const now=new Date();
  const zadnjih6=Array.from({length:6},(_,i)=>{
    const d=new Date(now.getFullYear(),now.getMonth()-5+i,1);
    const ym=d.toISOString().slice(0,7);
    return{ym,label:MJES[d.getMonth()],data:byMonth[ym]||{novi:0,prihod:0}};
  });
  const maxPrihod=Math.max(...zadnjih6.map(m=>m.data.prihod),1);

  return(
    <div style={{padding:mob?"16px":"0"}}>
      <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800,marginBottom:16,paddingTop:mob?8:0}}>💰 SaaS Finansije</div>

      {/* Glavni stats */}
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:mob?10:14,marginBottom:20}}>
        <Stat label="Aktivni kupci"   value={aktivni.length}   icon="✅" color={C.green}  bg="#0d2318" small={mob}/>
        <Stat label="Trial"           value={trial.length}     icon="⏳" color={C.yellow} bg="#1c1300" small={mob}/>
        <Stat label="Mj. prihod"      value={`${mjZarada} €`}  icon="💶" color={C.accent} bg={C.adim}  small={mob}/>
        <Stat label="God. prihod"     value={`${godZarada} €`} icon="📈" color={C.purple} bg={C.pdim}  small={mob}/>
      </div>

      {/* Trial vs Aktivni vizual */}
      <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:mob?14:20,marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:13,marginBottom:12}}>👥 Struktura kupaca</div>
        <div style={{display:"flex",gap:8,marginBottom:10}}>
          {[
            {label:"Aktivni",count:aktivni.length,color:C.green,bg:"#0d2318"},
            {label:"Trial",count:trial.length,color:C.yellow,bg:"#1c1300"},
            {label:"Istekli",count:istekli.length,color:C.red,bg:"#1f0d0d"},
          ].map(s=>(
            <div key={s.label} style={{flex:1,background:s.bg,border:`1px solid ${s.color}33`,borderRadius:10,padding:"10px 12px",textAlign:"center"}}>
              <div style={{fontSize:mob?20:26,fontWeight:800,color:s.color}}>{s.count}</div>
              <div style={{fontSize:11,color:C.muted,marginTop:2}}>{s.label}</div>
            </div>
          ))}
        </div>
        {/* Progress bar */}
        {kupci.length>0&&(
          <div style={{height:8,background:C.bg,borderRadius:4,overflow:"hidden",display:"flex"}}>
            {aktivni.length>0&&<div style={{width:`${aktivni.length/kupci.length*100}%`,background:C.green,transition:"width 0.5s"}}/>}
            {trial.length>0&&<div style={{width:`${trial.length/kupci.length*100}%`,background:C.yellow,transition:"width 0.5s"}}/>}
            {istekli.length>0&&<div style={{width:`${istekli.length/kupci.length*100}%`,background:C.red,transition:"width 0.5s"}}/>}
          </div>
        )}
      </div>

      {/* Grafikon zadnjih 6 mjeseci */}
      <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:mob?14:20,marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:13,marginBottom:14}}>📊 Prihod po mjesecima (zadnjih 6)</div>
        <div style={{display:"flex",gap:mob?6:10,alignItems:"flex-end",height:120}}>
          {zadnjih6.map(m=>{
            const h=Math.max((m.data.prihod/maxPrihod)*100,m.data.prihod>0?4:0);
            return(
              <div key={m.ym} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                {m.data.prihod>0&&<div style={{fontSize:9,color:C.accent,fontWeight:700}}>{m.data.prihod}€</div>}
                <div style={{width:"100%",height:`${h}%`,minHeight:m.data.prihod>0?4:0,background:m.data.prihod>0?"linear-gradient(180deg,#38bdf8,#0ea5e9)":"#1e2538",borderRadius:"4px 4px 0 0",transition:"height 0.5s"}}/>
                <div style={{fontSize:mob?9:10,color:C.muted,fontWeight:500}}>{m.label}</div>
                {m.data.novi>0&&<div style={{fontSize:9,color:C.green}}>+{m.data.novi}</div>}
              </div>
            );
          })}
        </div>
      </div>

      {/* Uskoro ističe */}
      {uskoro.length>0&&(
        <div style={{background:"#1c1300",border:`1px solid ${C.yellow}44`,borderRadius:14,padding:mob?14:18,marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:13,color:C.yellow,marginBottom:10}}>⚠️ Uskoro ističe pretplata ({uskoro.length})</div>
          {uskoro.map(k=>(
            <div key={k.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:`1px solid ${C.border}`,fontSize:13}}>
              <span style={{color:C.text}}>{k.email}</span>
              <span style={{color:C.yellow,fontWeight:600}}>{daysLeft(k.istice)}d · {k.cijena?k.cijena+" €/mj":"-"}</span>
            </div>
          ))}
        </div>
      )}

      {/* Lista aktivnih kupaca sa cijenama */}
      <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
        <div style={{padding:"12px 16px",borderBottom:`1px solid ${C.border}`,fontWeight:700,fontSize:13,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>💳 Aktivne pretplate</span>
          <span style={{color:C.accent,fontSize:12}}>{mjZarada} €/mj</span>
        </div>
        {aktivni.length===0?(
          <div style={{padding:"30px",textAlign:"center",color:C.muted,fontSize:13}}>Nema aktivnih pretplata</div>
        ):aktivni.map((k,i)=>(
          <div key={k.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 16px",borderBottom:i<aktivni.length-1?`1px solid ${C.border}`:"none",fontSize:13}}>
            <div>
              <div style={{fontWeight:500}}>{k.email}</div>
              {k.naziv&&<div style={{fontSize:11,color:C.muted}}>{k.naziv}</div>}
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{color:C.green,fontWeight:700}}>{k.cijena?k.cijena+" €/mj":"-"}</div>
              <div style={{fontSize:11,color:daysLeft(k.istice)<=7?C.yellow:C.muted}}>do {fmtDate(k.istice)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ══ KUPCI PAGE (admin) ════════════════════════════════════
function KupciPage({kupci,loading,saveKupac,delKupac,showToast}){
  const mob=isMobile();
  const [showAdd,setShowAdd]=useState(false);
  const [editKupac,setEditKupac]=useState(null);

  const aktivni=kupci.filter(k=>k.status==="active");
  const trial=kupci.filter(k=>k.status==="trial");
  const istekli=kupci.filter(k=>k.status==="expired"||daysLeft(k.istice)<=0);
  const registrirani=kupci.filter(k=>k.registriran_bool);
  const cekaju=kupci.filter(k=>!k.registriran_bool);

  return(
    <div style={{padding:mob?"16px":"0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,paddingTop:mob?8:0}}>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800}}>👤 Upravljanje kupcima</div>
        <button onClick={()=>setShowAdd(true)} style={{padding:"9px 16px",borderRadius:10,border:"none",background:"linear-gradient(135deg,#0ea5e9,#6366f1)",color:"#fff",fontWeight:700,fontSize:13,cursor:"pointer"}}>+ Dodaj</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:mob?8:14,marginBottom:16}}>
        <Stat label="Aktivni"     value={aktivni.length}     icon="✅" color={C.green}  bg="#0d2318" small/>
        <Stat label="Trial"       value={trial.length}       icon="⏳" color={C.yellow} bg="#1c1300" small/>
        <Stat label="Registrirani" value={registrirani.length} icon="👤" color={C.accent} bg={C.adim}  small/>
        <Stat label="Čekaju reg." value={cekaju.length}      icon="📧" color={C.orange} bg="#1c0f00" small/>
      </div>
      {loading?<div style={{textAlign:"center",padding:40,color:C.muted}}>Učitavanje...</div>:(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {kupci.map(k=>{
            const lic=LICENCE(k.status==="trial"&&daysLeft(k.istice)<=0?"expired":k.status);
            const dl=daysLeft(k.istice);
            return(
              <div key={k.id} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"14px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                  <div>
                    <div style={{fontWeight:600,fontSize:14}}>{k.email}</div>
                    {k.naziv&&<div style={{fontSize:12,color:C.muted,marginTop:2}}>{k.naziv}</div>}
                  </div>
                  <span style={{fontSize:10,padding:"3px 9px",borderRadius:5,background:lic.bg,color:lic.color,border:`1px solid ${lic.border}`,fontWeight:700,whiteSpace:"nowrap"}}>{lic.label}</span>
                </div>
                <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10,alignItems:"center"}}>
                  <span style={{fontSize:11,color:C.muted}}>Istek: <span style={{color:dl<0?C.red:dl<=7?C.yellow:C.text,fontWeight:600}}>{fmtDate(k.istice)}</span></span>
                  {k.cijena&&<span style={{fontSize:11,color:C.muted}}>· {k.cijena} EUR/mj</span>}
                  {k.registriran_bool
                    ?<span style={{fontSize:10,padding:"2px 8px",borderRadius:5,background:"#0d2318",color:C.green,border:"1px solid #166534",fontWeight:700}}>✅ Registriran {fmtDate(k.registriran)}</span>
                    :<span style={{fontSize:10,padding:"2px 8px",borderRadius:5,background:"#1c1300",color:C.yellow,border:"1px solid #78350f",fontWeight:700}}>⏳ Čeka registraciju</span>
                  }
                </div>
                <div style={{display:"flex",gap:8}}>
                  {k.status==="trial"&&<button onClick={async()=>{const nk={...k,status:"active",istice:addMonths(today(),1)};await saveKupac(nk);showToast(`✅ ${k.email} aktiviran!`);}} style={{flex:1,padding:"8px",borderRadius:9,border:`1px solid ${C.green}44`,background:"#0d2318",color:C.green,fontSize:12,fontWeight:700,cursor:"pointer"}}>✅ Aktiviraj</button>}
                  {k.status==="active"&&<button onClick={async()=>{const nk={...k,istice:addMonths(k.istice,1)};await saveKupac(nk);showToast(`✅ Produženo za 1 mj`);}} style={{flex:1,padding:"8px",borderRadius:9,border:`1px solid ${C.accent}44`,background:C.adim,color:C.accent,fontSize:12,fontWeight:700,cursor:"pointer"}}>🔄 Produži +1mj</button>}
                  {(k.status==="expired"||(k.status==="trial"&&dl<=0))&&<button onClick={async()=>{const nk={...k,status:"active",istice:addMonths(today(),1)};await saveKupac(nk);showToast(`✅ Reaktiviran!`);}} style={{flex:1,padding:"8px",borderRadius:9,border:`1px solid ${C.green}44`,background:"#0d2318",color:C.green,fontSize:12,fontWeight:700,cursor:"pointer"}}>🔄 Reaktiviraj</button>}
                  <button onClick={()=>setEditKupac(k)} style={{padding:"8px 12px",borderRadius:9,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:12,cursor:"pointer"}}>✏️</button>
                  <button onClick={async()=>{await delKupac(k.id);showToast("Obrisan","warn");}} style={{padding:"8px 12px",borderRadius:9,border:`1px solid ${C.red}33`,background:"#1f0d0d",color:C.red,fontSize:12,cursor:"pointer"}}>🗑️</button>
                </div>
              </div>
            );
          })}
          {kupci.length===0&&<div style={{textAlign:"center",padding:"40px",background:C.card,border:`1px solid ${C.border}`,borderRadius:14,color:C.muted}}><div style={{fontSize:36,marginBottom:10}}>👤</div><div>Nema kupaca. Dodaj prvog!</div></div>}
        </div>
      )}
      {showAdd&&<DodajKupcaModal onClose={()=>setShowAdd(false)} onSave={async k=>{await saveKupac(k);showToast(`✅ ${k.email} dodan!`);}}/>}
      {editKupac&&<DodajKupcaModal existing={editKupac} onClose={()=>setEditKupac(null)} onSave={async k=>{await saveKupac(k);showToast("Ažurirano");setEditKupac(null);}}/>}
    </div>
  );
}

// ══ DODAJ KUPCA MODAL ═════════════════════════════════════
function DodajKupcaModal({onClose,onSave,existing}){
  const [f,sf]=useState({email:existing?.email||"",naziv:existing?.naziv||"",status:existing?.status||"trial",cijena:existing?.cijena||"",trajanje:existing?.trajanje||"1"});
  const [err,setErr]=useState("");
  const [saved,setSaved]=useState(null);
  const [copied,setCopied]=useState(false);
  const F=(k,v)=>sf(p=>({...p,[k]:v}));
  const isTrial=f.status==="trial";
  const istice=isTrial?addDays(today(),7):addMonths(today(),parseInt(f.trajanje||1));
  const regLink=`${window.location.origin}/?register=1`;

  const submit=async()=>{
    setErr("");
    if(!f.email.trim()){setErr("Email je obavezan!");return;}
    if(!f.email.trim().includes("@")||!f.email.trim().includes(".")){setErr("Email nije ispravan!");return;}
    const k={email:f.email.trim().toLowerCase(),naziv:f.naziv.trim(),status:f.status,istice,cijena:f.cijena,trajanje:f.trajanje,kreiran:existing?.kreiran||today()};
    try{
      console.log("Saving kupac:", k);
      await onSave(k);
      console.log("Saved OK");
      const rLink=`${window.location.origin}`;
      const sent=await sendWelcomeEmail({toEmail:k.email,naziv:k.naziv,status:k.status,istice:k.istice,regLink:rLink});
      setSaved({...k,emailSent:sent});
    }catch(e){
      console.error("Submit error:", e);
      setErr("Greška: "+e.message);
    }
  };

  const copyLink=(k)=>{
    const ime=k.naziv?k.naziv.split(" ")[0]:"";
    const isTr=k.status==="trial";
    const msg=`Pozdrav${ime?" "+ime:""}!\n\nVaš IPTV Manager pristup je aktiviran.\n${isTr?"Imate 7 dana besplatnog trial perioda.":`Pristup aktivan do ${fmtDate(k.istice)}.`}\n\nRegistrirajte se ovdje:\n${regLink}\n\nEmail za prijavu: ${k.email}\n\nAko imate pitanja, javite se.`;
    navigator.clipboard.writeText(msg).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),3000);});
  };

  if(saved) return(
    <Modal title="✅ Kupac dodan!" onClose={onClose}>
      <div style={{background:"#0d2318",border:`1px solid #166534`,borderRadius:12,padding:"14px 16px",marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:14,color:C.green,marginBottom:4}}>{saved.email}</div>
        <div style={{fontSize:12,color:C.muted}}>{saved.status==="trial"?"Trial 7 dana":"Aktivan"} · Ističe {fmtDate(saved.istice)}</div>
      </div>
      <div style={{background:saved.emailSent?"#0d2318":EJS_SERVICE==="YOUR_SERVICE_ID"?"#1c1300":"#1f0d0d",border:`1px solid ${saved.emailSent?"#166534":EJS_SERVICE==="YOUR_SERVICE_ID"?"#78350f":"#7f1d1d"}`,borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13}}>
        {saved.emailSent
          ?<span style={{color:C.green}}>✅ Pozivni email poslan na {saved.email}</span>
          :EJS_SERVICE==="YOUR_SERVICE_ID"
            ?<span style={{color:C.yellow}}>⚠️ EmailJS nije podešen — kopiraj poruku ispod i pošalji ručno</span>
            :<span style={{color:C.red}}>❌ Email nije poslan — provjeri EmailJS konfiguraciju</span>
        }
      </div>
      <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:10,padding:"12px 14px",marginBottom:14}}>
        <div style={{fontSize:11,color:C.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:0.8}}>Link za registraciju</div>
        <div style={{fontSize:13,color:C.accent,wordBreak:"break-all",marginBottom:10}}>{regLink}</div>
        <div style={{fontSize:11,color:C.muted,marginBottom:10}}>Pošalji ovo kupcu da se registrira:</div>
        <button onClick={()=>copyLink(saved)} style={{...BP,background:copied?"#166534":"linear-gradient(135deg,#0ea5e9,#6366f1)"}}>
          {copied?"✅ Poruka kopirana! Zalijepi u WhatsApp/Viber":"📋 Kopiraj poruku za slanje"}
        </button>
      </div>
      <button onClick={onClose} style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:14,cursor:"pointer"}}>Zatvori</button>
    </Modal>
  );

  return(
    <Modal title={existing?"Uredi kupca":"Dodaj kupca"} onClose={onClose}>
      <FR label="Email adresa"><input style={{...IS,borderColor:err&&!f.email.trim()?C.red:C.border}} type="email" value={f.email} onChange={e=>{F("email",e.target.value);setErr("");}} placeholder="kupac@email.com" disabled={!!existing}/></FR>
      <FR label="Naziv (opcionalno)"><input style={IS} value={f.naziv} onChange={e=>F("naziv",e.target.value)} placeholder="npr. Marko — IPTV Sarajevo"/></FR>
      <T3 label="Tip pristupa" value={f.status} onChange={v=>F("status",v)} opts={[{v:"trial",l:"⏳ Trial 7 dana",c:C.yellow},{v:"active",l:"✅ Aktivan",c:C.green},{v:"blocked",l:"🔒 Blokiran",c:C.red}]}/>
      {!isTrial&&<FR label="Trajanje (mjeseci)"><input style={IS} type="number" min="1" max="12" value={f.trajanje} onChange={e=>F("trajanje",e.target.value)} inputMode="numeric"/></FR>}
      <FR label="Cijena (EUR/mj, opcionalno)"><input style={IS} type="number" min="0" step="1" value={f.cijena} onChange={e=>F("cijena",e.target.value)} placeholder="npr. 10" inputMode="decimal"/></FR>
      <div style={{background:C.adim,borderRadius:10,padding:"11px 14px",marginBottom:err?10:16,fontSize:13}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><span style={{color:C.muted}}>Tip:</span><span style={{color:isTrial?C.yellow:C.green,fontWeight:700}}>{isTrial?"Trial 7 dana":"Aktivan"}</span></div>
        <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:C.muted}}>Ističe:</span><span style={{fontWeight:700}}>{fmtDate(istice)}</span></div>
      </div>
      {err&&<div style={{color:C.red,fontSize:13,marginBottom:14,padding:"8px 12px",background:"#1f0d0d",borderRadius:8,border:`1px solid ${C.red}44`}}>⚠️ {err}</div>}
      <button onClick={submit} style={BP}>{existing?"Spremi izmjene":"Dodaj kupca"}</button>
    </Modal>
  );
}

// ══ TENANT APP (regular user) ════════════════════════════
function TenantApp({user,licence,showToast,toast,mob,loading,users,credits,crHist,saveCredits,saveCrHist,saveUser,delUser,page,setPage,modal,setModal,activeUser,setActiveUser}){
  const dl=licence.status==="trial"?daysLeft(licence.istice):null;
  return(
    <div style={{minHeight:"100vh",background:C.bg,fontFamily:"'DM Sans',system-ui,sans-serif",color:C.text}}>
      {/* Trial banner */}
      {licence.status==="trial"&&dl!==null&&dl>0&&(
        <div style={{background:"#1c1300",borderBottom:`1px solid ${C.yellow}44`,padding:"8px 16px",textAlign:"center",fontSize:12,color:C.yellow}}>
          ⏳ Trial period — još <strong>{dl} dana</strong>. Kontaktiraj admina za aktivaciju: {ADMIN_EMAIL}
        </div>
      )}
      <TenantContent mob={mob} loading={loading} users={users} credits={credits} crHist={crHist} saveCredits={saveCredits} saveCrHist={saveCrHist} saveUser={saveUser} delUser={delUser} page={page} setPage={setPage} modal={modal} setModal={setModal} activeUser={activeUser} setActiveUser={setActiveUser} showToast={showToast} user={user}/>
      <Toast t={toast}/>
    </div>
  );
}

// ══ TENANT CONTENT (shared between admin's own IPTV and regular users) ════
function TenantContent({mob,loading,users,credits,crHist,saveCredits,saveCrHist,saveUser,delUser,page,setPage,modal,setModal,activeUser,setActiveUser,showToast,user,isAdminView,onSwitchAdmin}){
  const desktopNav=[
    {id:"dashboard",icon:"📊",label:"Dashboard"},
    {id:"dodaj",    icon:"➕",label:"Dodaj korisnika"},
    {id:"import",   icon:"📥",label:"Import CSV"},
    {id:"korisnici",icon:"👥",label:"Korisnici"},
    {id:"dugovanja",icon:"💸",label:"Dugovanja"},
    {id:"rekap",    icon:"📋",label:"Rekapitulacija"},
    {id:"krediti",  icon:"💳",label:"Krediti"},
  ];
  const mobileNav=[
    {id:"dashboard", icon:"📊",label:"Home"},
    {id:"korisnici", icon:"👥",label:"Korisnici"},
    {id:"dodaj",     icon:"➕",label:"Dodaj"},
    {id:"dugovanja", icon:"💸",label:"Dugovi"},
    {id:"more",      icon:"⋯", label:"Više"},
  ];

  const extendSave=async e=>{
    const dl=daysLeft(activeUser.expiry);
    const ne=dl>=0?addMonths(activeUser.expiry,e.ukupnoMj):addMonths(today(),e.ukupnoMj);
    const hist=[...(activeUser.historija||[])];
    // Ako split mode — dodaj dva unosa
    if(e.splitMode&&e.placenoMj>0&&e.gratisMj>0){
      if(e.placenoMj>0) hist.push({datum:today(),tip:"produženje",mjeseci:e.placenoMj,payStatus:"placeno",cijenaKM:e.km,krediti:e.placenoMj});
      if(e.gratisMj>0)  hist.push({datum:today(),tip:"produženje",mjeseci:e.gratisMj,payStatus:"gratis",cijenaKM:0,krediti:e.gratisMj});
    }else{
      // Bez splita — ako ima km onda plaćeno, inače gratis
      const pay=e.km>0?"placeno":"gratis";
      hist.push({datum:today(),tip:"produženje",mjeseci:e.ukupnoMj,payStatus:pay,cijenaKM:e.km,krediti:e.ukupnoMj});
    }
    const finalPay=e.placenoMj>0?"placeno":e.gratisMj===e.ukupnoMj?"gratis":"placeno";
    const u={...activeUser,expiry:ne,payStatus:finalPay,cijenaKM:e.km,historija:hist};
    await saveUser(u);await saveCredits(credits-e.ukupnoMj);
    showToast(`✅ Produženo ${e.ukupnoMj}mj → ${fmtDate(ne)}`);setModal(null);
  };
  const uplataSave=async e=>{
    const entry={datum:today(),tip:"uplata",payStatus:e.pay,cijenaKM:e.km};
    const u={...activeUser,payStatus:e.pay,cijenaKM:e.km,historija:[...(activeUser.historija||[]),entry]};
    await saveUser(u);showToast(`✅ Status → ${PAY(e.pay).label}`);setModal(null);
  };
  const deleteSave=async()=>{await delUser(activeUser.id);showToast("Obrisan","warn");setModal(null);};

  const pages=(
    <>
      {page==="dashboard" &&<DashPage   users={users} credits={credits} crHist={crHist}/>}
      {page==="dodaj"     &&<DodajPage  credits={credits} saveCredits={saveCredits} saveUser={saveUser} showToast={showToast} setPage={setPage}/>}
      {page==="import"    &&<ImportPage users={users} saveUser={saveUser} credits={credits} saveCredits={saveCredits} showToast={showToast} setPage={setPage}/>}
      {page==="korisnici" &&<KorPage    users={users} setModal={setModal} setActiveUser={setActiveUser}/>}
      {page==="dugovanja" &&<DugPage    users={users}/>}
      {page==="rekap"     &&<RekapPage  users={users} crHist={crHist}/>}
      {page==="krediti"   &&<KrediPage  credits={credits} saveCredits={saveCredits} crHist={crHist} saveCrHist={saveCrHist} showToast={showToast} users={users}/>}
      {page==="more"      &&<MorePage   setPage={setPage} user={user}/>}
    </>
  );

  const modals=(
    <>
      {modal==="extend"&&activeUser&&<ExtendModal u={activeUser} credits={credits} onClose={()=>setModal(null)} onSave={extendSave}/>}
      {modal==="delete"&&activeUser&&<Modal title="Obrisati korisnika?" onClose={()=>setModal(null)}><div style={{color:C.muted,marginBottom:6,fontWeight:600}}>{activeUser.ime}</div><div style={{color:C.muted,fontSize:13,marginBottom:24}}>Ova akcija je trajna.</div><div style={{display:"flex",gap:10}}><button onClick={deleteSave} style={{...BP,background:"#7f1d1d"}}>🗑️ Obriši</button><button onClick={()=>setModal(null)} style={{flex:1,padding:"13px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,cursor:"pointer",fontSize:14}}>Otkaži</button></div></Modal>}
      {modal==="uplata"&&activeUser&&<PromijeniUplatuModal u={activeUser} onClose={()=>setModal(null)} onSave={uplataSave}/>}
      {modal==="edit"&&activeUser&&<EditUserModal u={activeUser} onClose={()=>setModal("userDetail")} onSave={async(updated)=>{await saveUser(updated);setActiveUser(updated);showToast("✅ Podaci ažurirani!");setModal("userDetail");}}/>}
      {modal==="userDetail"&&activeUser&&<UserDetailModal u={activeUser} onClose={()=>setModal(null)} onEdit={()=>setModal("edit")} onExtend={()=>setModal("extend")} onDelete={()=>setModal("delete")} onUplata={()=>setModal("uplata")} onVivoToggle={async()=>{
        const cost=activeUser.vivo?0:5;
        if(!activeUser.vivo&&credits<5){showToast("Nedovoljno kredita za Vivo (+5)","err");return;}
        const entry={datum:today(),tip:"uplata",payStatus:activeUser.payStatus,cijenaKM:0,napomena:activeUser.vivo?"Uklonjen Vivo Player":"Dodan Vivo Player"};
        const u={...activeUser,vivo:!activeUser.vivo,historija:[...(activeUser.historija||[]),entry]};
        await saveUser(u);
        if(!activeUser.vivo) await saveCredits(credits-5);
        setActiveUser(u);
        showToast(activeUser.vivo?"📺 Vivo uklonjen":"✅ Vivo dodan! −5 kredita");
      }}/>}
    </>
  );

  if(!mob) return(
    <div style={{display:"flex"}}>
      <div style={{width:230,background:C.panel,borderRight:`1px solid ${C.border}`,display:"flex",flexDirection:"column",position:"fixed",top:0,bottom:0,left:0,zIndex:50}}>
        <div style={{padding:"22px 18px 14px"}}><div style={{fontFamily:"'Syne',sans-serif",fontSize:19,fontWeight:800}}>📡 IPTV Manager</div></div>
        <div style={{margin:"0 12px 14px",background:C.adim,border:`1px solid #0c3d5a`,borderRadius:10,padding:"10px 14px"}}>
          <div style={{fontSize:10,color:C.accent,textTransform:"uppercase",letterSpacing:0.8}}>Dostupni krediti</div>
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:26,fontWeight:800,color:C.accent}}>{credits}</div>
        </div>
        <nav style={{flex:1,padding:"0 8px",overflowY:"auto"}}>
          {desktopNav.map(n=><button key={n.id} onClick={()=>setPage(n.id)} style={{width:"100%",display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,border:"none",cursor:"pointer",marginBottom:2,textAlign:"left",background:page===n.id?"linear-gradient(135deg,#0c2d3f,#1e1a35)":"transparent",color:page===n.id?C.text:C.muted,fontSize:13,fontWeight:page===n.id?600:400,borderLeft:page===n.id?`2px solid ${C.accent}`:"2px solid transparent"}}><span style={{fontSize:15}}>{n.icon}</span>{n.label}</button>)}
        </nav>
        <div style={{padding:"12px",borderTop:`1px solid ${C.border}`}}>
          {isAdminView&&<button onClick={onSwitchAdmin} style={{width:"100%",padding:"9px",borderRadius:9,border:`1px solid ${C.orange}44`,background:"#1c0f00",color:C.orange,fontSize:12,fontWeight:700,cursor:"pointer",marginBottom:8}}>⚡ Natrag na Admin panel</button>}
          <div style={{fontSize:11,color:C.muted,marginBottom:8,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user?.email}</div>
          <button onClick={()=>signOut(auth)} style={{width:"100%",padding:"8px",borderRadius:9,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:12,cursor:"pointer"}}>🚪 Odjavi se</button>
        </div>
      </div>
      <div style={{marginLeft:230,flex:1,padding:"26px 32px"}}>
        {loading&&<div style={{position:"fixed",top:14,right:14,background:C.adim,border:`1px solid ${C.accent}`,color:C.accent,padding:"5px 12px",borderRadius:8,fontSize:12,zIndex:999}}>Učitavanje...</div>}
        {pages}
      </div>
      {modals}
    </div>
  );

  return(
    <div style={{paddingBottom:70}}>
      <div style={{maxWidth:600,margin:"0 auto"}}>
        {loading&&<div style={{position:"fixed",top:8,right:8,background:C.adim,border:`1px solid ${C.accent}`,color:C.accent,padding:"4px 10px",borderRadius:8,fontSize:11,zIndex:999}}>Sync...</div>}
        {pages}
      </div>
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:C.panel,borderTop:`1px solid ${C.border}`,display:"flex",zIndex:100,paddingBottom:"env(safe-area-inset-bottom)"}}>
        {mobileNav.map(t=>(
          <button key={t.id} onClick={()=>setPage(t.id)} style={{flex:1,padding:"10px 4px 8px",border:"none",background:"transparent",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
            <span style={{fontSize:19,lineHeight:1}}>{t.icon}</span>
            <span style={{fontSize:9,color:page===t.id?C.accent:C.muted,fontWeight:page===t.id?700:400}}>{t.label}</span>
            {page===t.id&&<div style={{width:14,height:2,background:C.accent,borderRadius:1}}/>}
          </button>
        ))}
      </div>
      {modals}
    </div>
  );
}

// ══ DASHBOARD ════════════════════════════════════════════
function DashPage({users,credits,crHist}){
  const mob=isMobile();
  const active=users.filter(u=>daysLeft(u.expiry)>=0).length;
  const expired=users.filter(u=>daysLeft(u.expiry)<0).length;
  const soon=users.filter(u=>{const d=daysLeft(u.expiry);return d>=0&&d<=7;}).length;
  const totalDug=users.filter(u=>u.payStatus==="nije_placeno").reduce((s,u)=>s+(parseFloat(u.cijenaKM)||0),0);
  const allH=users.flatMap(u=>u.historija||[]);
  const zarada=allH.filter(h=>h.payStatus==="placeno").reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  const kostKr=crHist.reduce((s,h)=>s+(parseFloat(h.placenoKM)||0),0);
  const profit=zarada-kostKr;
  const soonL=users.filter(u=>{const d=daysLeft(u.expiry);return d>=0&&d<=7;});
  const expL=users.filter(u=>daysLeft(u.expiry)<0).slice(0,5);
  return(
    <div style={{padding:mob?"16px 16px 8px":"0"}}>
      {mob&&<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,paddingTop:8}}>
        <div><div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800}}>📡 IPTV</div><div style={{fontSize:11,color:C.muted}}>Manager</div></div>
        <div style={{background:C.adim,border:`1px solid #0c3d5a`,borderRadius:12,padding:"8px 14px",textAlign:"right"}}><div style={{fontSize:10,color:C.accent,textTransform:"uppercase",letterSpacing:0.8}}>Krediti</div><div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800,color:C.accent}}>{credits}</div></div>
      </div>}
      {!mob&&<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}><div style={{fontFamily:"'Syne',sans-serif",fontSize:24,fontWeight:800}}>Dashboard</div></div>}
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr 1fr":"repeat(3,1fr)",gap:mob?10:16,marginBottom:mob?10:16}}>
        <Stat label="Korisnika"     value={users.length} icon="👥" color={C.purple} bg={C.pdim}  small={mob}/>
        <Stat label="Aktivni"       value={active}       icon="✅" color={C.green}  bg="#0d2318" small={mob}/>
        <Stat label="Istekli"       value={expired}      icon="❌" color={C.red}    bg="#1f0d0d" small={mob}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(3,1fr)",gap:mob?10:16,marginBottom:mob?10:16}}>
        <Stat label="Uskoro ističe" value={soon}            icon="⚠️" color={C.yellow} bg="#1c1300" small={mob}/>
        <Stat label="Duguju"        value={fmtKM(totalDug)} icon="💸" color={C.orange} bg="#1c0f00" small={mob}/>
        {!mob&&<Stat label="Krediti" value={credits} icon="💳" color={C.accent} bg={C.adim}/>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:mob?10:16,marginBottom:mob?16:20}}>
        {[["💰",fmtKM(zarada),"Naplaćeno",C.green],["💸",fmtKM(kostKr),"Za kredite",C.red],[profit>=0?"📈":"📉",fmtKM(profit),"Profit",profit>=0?C.accent:C.red]].map(([ic,v,l,c])=>(
          <div key={l} style={{background:C.card,border:`1px solid ${c}22`,borderRadius:mob?12:14,padding:mob?"10px 12px":"16px 18px"}}>
            <div style={{fontSize:mob?16:22}}>{ic}</div>
            <div style={{fontSize:mob?13:22,fontWeight:800,color:c,marginTop:4}}>{v}</div>
            <div style={{fontSize:mob?10:12,color:C.muted,marginTop:2}}>{l}</div>
          </div>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:mob?12:18}}>
        {soonL.length>0&&<div style={{background:C.card,border:`1px solid ${C.yellow}44`,borderRadius:14,padding:mob?14:18}}>
          <div style={{fontWeight:700,fontSize:11,color:C.yellow,marginBottom:10,textTransform:"uppercase",letterSpacing:0.8}}>⚠️ Uskoro ističe</div>
          {soonL.map(u=><div key={u.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:`1px solid ${C.border}`}}><div style={{fontWeight:500,fontSize:mob?13:14}}>{u.ime}</div><div style={{fontSize:12,color:C.yellow,fontWeight:600}}>{daysLeft(u.expiry)}d</div></div>)}
        </div>}
        {expL.length>0&&<div style={{background:C.card,border:`1px solid ${C.red}44`,borderRadius:14,padding:mob?14:18}}>
          <div style={{fontWeight:700,fontSize:11,color:C.red,marginBottom:10,textTransform:"uppercase",letterSpacing:0.8}}>❌ Isteklo</div>
          {expL.map(u=><div key={u.id} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:`1px solid ${C.border}`}}><div style={{fontWeight:500,fontSize:mob?13:14}}>{u.ime}</div><div style={{fontSize:12,color:C.red}}>{fmtDate(u.expiry)}</div></div>)}
        </div>}
      </div>
    </div>
  );
}

// ══ DODAJ ════════════════════════════════════════════════
function DodajPage({credits,saveCredits,saveUser,showToast,setPage}){
  const mob=isMobile();
  const [f,sf]=useState({ime:"",tel:"",mj:"1",pay:"placeno",km:"",vivo:false});
  const F=(k,v)=>sf(p=>({...p,[k]:v}));
  const cost=parseInt(f.mj||0)+(f.vivo?5:0);
  const submit=async()=>{
    if(!f.ime.trim()||!f.mj){showToast("Unesite barem ime i broj mjeseci","err");return;}
    if(cost>credits){showToast(`Nedovoljno kredita! Trebate ${cost}`,"err");return;}
    const entry={datum:today(),tip:"novi",mjeseci:parseInt(f.mj),payStatus:f.pay,cijenaKM:parseFloat(f.km||0),krediti:cost};
    const nu={id:uid(),ime:f.ime.trim(),telefon:f.tel.trim(),vivo:f.vivo,expiry:addMonths(today(),f.mj),payStatus:f.pay,cijenaKM:parseFloat(f.km||0),kreiran:today(),historija:[entry]};
    await saveUser(nu);await saveCredits(credits-cost);
    showToast(`✅ ${f.ime} dodan! −${cost} kredita`);
    sf({ime:"",tel:"",mj:"1",pay:"placeno",km:"",vivo:false});setPage("korisnici");
  };
  return(
    <div style={{padding:mob?"16px":"0",maxWidth:mob?"100%":560}}>
      {mob&&<div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800,marginBottom:16,paddingTop:8}}>➕ Dodaj korisnika</div>}
      {!mob&&<div style={{fontFamily:"'Syne',sans-serif",fontSize:24,fontWeight:800,marginBottom:22}}>➕ Dodaj korisnika</div>}
      <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:16,padding:mob?16:24}}>
        <FR label="Ime i prezime"><input style={IS} value={f.ime} onChange={e=>F("ime",e.target.value)} placeholder="npr. Marko Marković"/></FR>
        <FR label="Telefon (opcionalno)"><input style={IS} value={f.tel} onChange={e=>F("tel",e.target.value)} placeholder="+387 61 123 456" type="tel"/></FR>
        <FR label="Broj mjeseci"><input style={IS} type="number" min="1" max="24" value={f.mj} onChange={e=>F("mj",e.target.value)} inputMode="numeric"/></FR>
        <T3 label="Status uplate" value={f.pay} onChange={v=>F("pay",v)} opts={[{v:"placeno",l:"✅ Plaćeno",c:C.green},{v:"nije_placeno",l:"❌ Nije plaćeno",c:C.red},{v:"gratis",l:"🎁 Gratis",c:C.purple}]}/>
        {f.pay!=="gratis"&&<FR label={`Cijena (KM)${f.pay==="nije_placeno"?" — dugovanje":""}`}><input style={{...IS,borderColor:f.pay==="nije_placeno"?C.red:C.border}} type="number" min="0" step="0.5" value={f.km} onChange={e=>F("km",e.target.value)} placeholder="npr. 10.00" inputMode="decimal"/></FR>}
        <div style={{marginBottom:18}}><button onClick={()=>F("vivo",!f.vivo)} style={{width:"100%",padding:"12px 14px",borderRadius:10,border:`1.5px solid ${f.vivo?C.purple:C.border}`,background:f.vivo?`${C.purple}18`:C.bg,color:f.vivo?C.purple:C.muted,fontSize:14,fontWeight:500,cursor:"pointer",textAlign:"left"}}>{f.vivo?"✅":"⬜"} 📺 Vivo Player (+5 kredita)</button></div>
        <div style={{background:C.adim,borderRadius:10,padding:"12px 14px",marginBottom:18}}>
          {[["Trošak",`${cost} kr`,cost>credits?C.red:C.accent],["Dostupno",`${credits} kr`,credits>=cost?C.green:C.red],["Istek",f.mj?fmtDate(addMonths(today(),f.mj)):"—",C.text],["Uplata",f.pay==="gratis"?"🎁 Gratis":fmtKM(f.km||0),f.pay==="gratis"?C.purple:f.pay==="placeno"?C.green:C.red]].map(([l,v,c])=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:5}}><span style={{color:C.muted}}>{l}:</span><span style={{color:c,fontWeight:700}}>{v}</span></div>
          ))}
        </div>
        <button onClick={submit} style={BP}>Dodaj korisnika</button>
      </div>
    </div>
  );
}

// ══ KORISNICI ════════════════════════════════════════════
function KorPage({users,setModal,setActiveUser}){
  const mob=isMobile();
  const [srch,setSrch]=useState("");
  const [flt,setFlt]=useState("svi");
  const fil=users.filter(u=>{const q=srch.toLowerCase();const m=u.ime.toLowerCase().includes(q)||(u.telefon||"").includes(q);const d=daysLeft(u.expiry);const s=flt==="svi"||(flt==="aktivan"&&d>=0)||(flt==="isteklo"&&d<0)||(flt==="uskoro"&&d>=0&&d<=7);return m&&s;});
  const csvRows=[["Ime","Telefon","Istek","Status","Uplata","Cijena KM","Vivo"],...fil.map(u=>[u.ime,u.telefon||"",u.expiry,STATUS(u.expiry).label,PAY(u.payStatus).label,u.cijenaKM||0,u.vivo?"Da":"Ne"])];
  return(
    <div style={{padding:mob?"16px":"0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,paddingTop:mob?8:0}}>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800}}>👥 Korisnici <span style={{fontSize:13,color:C.muted,fontWeight:400}}>({fil.length}/{users.length})</span></div>
        {!mob&&<CsvBtn label="Export CSV" rows={csvRows}/>}
      </div>
      <input placeholder="🔍  Pretraži..." value={srch} onChange={e=>setSrch(e.target.value)} style={{...IS,marginBottom:10}}/>
      <div style={{display:"flex",gap:6,marginBottom:14,overflowX:"auto",paddingBottom:4}}>
        {[["svi","Svi"],["aktivan","Aktivni"],["isteklo","Istekli"],["uskoro","Uskoro"]].map(([v,l])=>(
          <button key={v} onClick={()=>setFlt(v)} style={{padding:"7px 14px",borderRadius:20,border:`1px solid ${flt===v?C.accent:C.border}`,background:flt===v?C.adim:"transparent",color:flt===v?C.accent:C.muted,fontSize:12,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>{l}</button>
        ))}
      </div>
      {mob?(fil.length===0?<div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}><div style={{fontSize:36,marginBottom:10}}>📂</div><div>Nema korisnika</div></div>:(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {fil.map(u=>{const st=STATUS(u.expiry);const ps=PAY(u.payStatus);return(
            <div key={u.id} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
              <button onClick={()=>{setActiveUser(u);setModal("userDetail");}} style={{background:"none",border:"none",textAlign:"left",cursor:"pointer",width:"100%",padding:"14px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:7}}>
                  <div><div style={{fontWeight:600,fontSize:15}}>{u.ime}</div>{u.telefon&&<div style={{fontSize:12,color:C.muted,marginTop:2}}>{u.telefon}</div>}</div>
                  <span style={{fontSize:10,padding:"3px 9px",borderRadius:5,background:st.bg,color:st.color,border:`1px solid ${st.border}`,fontWeight:700,whiteSpace:"nowrap"}}>{st.label}</span>
                </div>
                <div style={{display:"flex",gap:7,flexWrap:"wrap",alignItems:"center"}}>
                  <span style={{fontSize:11,padding:"2px 8px",borderRadius:5,background:ps.bg,color:ps.color,fontWeight:600}}>{ps.label}</span>
                  {u.payStatus!=="gratis"&&<span style={{fontSize:11,color:C.muted}}>{fmtKM(u.cijenaKM)}</span>}
                  <span style={{fontSize:11,color:C.muted}}>↗ {fmtDate(u.expiry)}</span>
                  {u.vivo&&<span style={{fontSize:11,color:C.purple,background:C.pdim,padding:"2px 8px",borderRadius:5}}>Vivo</span>}
                </div>
              </button>
              <div style={{display:"flex",borderTop:`1px solid ${C.border}`}}>
                <button onClick={()=>{setActiveUser(u);setModal("edit");}} style={{flex:1,padding:"10px",background:"#1a0c2e",border:"none",color:"#a78bfa",fontSize:12,fontWeight:700,cursor:"pointer",borderRight:`1px solid ${C.border}`}}>✏️ Uredi</button>
                <button onClick={()=>{setActiveUser(u);setModal("extend");}} style={{flex:1,padding:"10px",background:C.adim,border:"none",color:C.accent,fontSize:12,fontWeight:700,cursor:"pointer",borderRight:`1px solid ${C.border}`}}>📅 Produži</button>
                <button onClick={()=>{setActiveUser(u);setModal("userDetail");}} style={{flex:1,padding:"10px",background:"transparent",border:"none",color:C.muted,fontSize:12,fontWeight:700,cursor:"pointer"}}>••• Više</button>
              </div>
            </div>
          );})}
        </div>
      )):(fil.length===0?<div style={{textAlign:"center",padding:"50px",background:C.card,border:`1px solid ${C.border}`,borderRadius:14,color:C.muted}}><div style={{fontSize:36,marginBottom:10}}>📂</div><div style={{fontWeight:700}}>Nema korisnika</div></div>:(
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"1.4fr 110px 100px 100px 105px 80px 170px",padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.6}}>
            <span>Korisnik</span><span>Telefon</span><span>Istek</span><span>Status</span><span>Uplata</span><span>Cijena</span><span style={{textAlign:"right"}}>Akcije</span>
          </div>
          {fil.map((u,i)=>{const st=STATUS(u.expiry);const ps=PAY(u.payStatus);return(
            <div key={u.id} style={{display:"grid",gridTemplateColumns:"1.4fr 110px 100px 100px 105px 80px 170px",padding:"12px 18px",alignItems:"center",borderBottom:i<fil.length-1?`1px solid ${C.border}`:"none",transition:"background 0.1s"}} onMouseEnter={e=>e.currentTarget.style.background="#161c2a"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div><div style={{fontWeight:500,fontSize:14}}>{u.ime}</div>{u.vivo&&<span style={{fontSize:10,color:C.purple,background:C.pdim,padding:"1px 6px",borderRadius:4}}>Vivo</span>}</div>
              <span style={{fontSize:12,color:C.muted}}>{u.telefon||"—"}</span>
              <span style={{fontSize:13}}>{fmtDate(u.expiry)}</span>
              <span><span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:st.bg,color:st.color,border:`1px solid ${st.border}`,fontWeight:700}}>{st.label}</span></span>
              <span><span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:ps.bg,color:ps.color,fontWeight:700}}>{ps.label}</span></span>
              <span style={{fontSize:13,fontWeight:600,color:u.payStatus==="gratis"?C.purple:u.payStatus==="placeno"?C.green:C.red}}>{u.payStatus==="gratis"?"—":fmtKM(u.cijenaKM)}</span>
              <span style={{display:"flex",gap:4,justifyContent:"flex-end"}}>
                <button onClick={()=>{setActiveUser(u);setModal("edit");}} style={{background:"#1a0c2e",border:`1px solid #4c1d95`,borderRadius:7,color:"#a78bfa",padding:"5px 7px",cursor:"pointer",fontSize:12}} title="Uredi">✏️</button>
                <button onClick={()=>genPDF(u)} style={{background:"#0c1a30",border:`1px solid #1e3a5f`,borderRadius:7,color:"#93c5fd",padding:"5px 7px",cursor:"pointer",fontSize:12}} title="PDF">🖨️</button>
                <button onClick={()=>{setActiveUser(u);setModal("uplata");}} style={{background:"#0d2318",border:`1px solid #166534`,borderRadius:7,color:C.green,padding:"5px 7px",cursor:"pointer",fontSize:12}} title="Uplata">💳</button>
                <button onClick={()=>{setActiveUser(u);setModal("extend");}} style={{background:C.adim,border:`1px solid #0c3d5a`,borderRadius:7,color:C.accent,padding:"5px 7px",cursor:"pointer",fontSize:12}} title="Produži">📅</button>
                <button onClick={async()=>{
                  if(!u.vivo&&credits<5){showToast("Nedovoljno kredita za Vivo (+5)","err");return;}
                  const entry={datum:today(),tip:"uplata",payStatus:u.payStatus,cijenaKM:0,napomena:u.vivo?"Uklonjen Vivo Player":"Dodan Vivo Player"};
                  const nu={...u,vivo:!u.vivo,historija:[...(u.historija||[]),entry]};
                  await saveUser(nu);
                  if(!u.vivo) await saveCredits(credits-5);
                  showToast(u.vivo?"📺 Vivo uklonjen":"✅ Vivo dodan! −5 kredita");
                }} style={{background:u.vivo?`${C.purple}18`:"transparent",border:`1px solid ${u.vivo?C.purple:C.border}`,borderRadius:7,color:u.vivo?C.purple:C.muted,padding:"5px 7px",cursor:"pointer",fontSize:12}} title={u.vivo?"Ukloni Vivo":"Dodaj Vivo"}>📺</button>
                <button onClick={()=>{setActiveUser(u);setModal("delete");}} style={{background:"#1f0d0d",border:"1px solid #3d1515",borderRadius:7,color:C.red,padding:"5px 7px",cursor:"pointer",fontSize:12}} title="Obriši">🗑️</button>
              </span>
            </div>
          );})}
        </div>
      ))}
    </div>
  );
}

// ══ USER DETAIL MODAL ═════════════════════════════════════
// ══ EDIT USER MODAL ══════════════════════════════════════════
function EditUserModal({u,onClose,onSave}){
  const [ime,setIme]=useState(u.ime||"");
  const [telefon,setTelefon]=useState(u.telefon||"");
  const [cijenaKM,setCijenaKM]=useState(u.cijenaKM||"");
  const [loading,setLoading]=useState(false);

  const save=async()=>{
    if(!ime.trim()){return;}
    setLoading(true);
    try{
      await onSave({...u,ime:ime.trim(),telefon:telefon.trim(),cijenaKM:parseFloat(cijenaKM)||0});
    }catch(e){console.error("Edit save error:",e);}
    setLoading(false);
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.panel,border:`1px solid ${C.border}`,borderRadius:20,padding:24,width:"100%",maxWidth:400,boxShadow:"0 24px 64px rgba(0,0,0,0.6)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:17,fontWeight:800}}>✏️ Uredi korisnika</div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,fontSize:20,cursor:"pointer"}}>×</button>
        </div>
        <FR label="Ime i prezime">
          <input value={ime} onChange={e=>setIme(e.target.value)} style={IS} placeholder="Ime i prezime"/>
        </FR>
        <FR label="Telefon">
          <input value={telefon} onChange={e=>setTelefon(e.target.value)} style={IS} placeholder="+387 61 000 000"/>
        </FR>
        <FR label="Cijena (KM)">
          <input type="number" value={cijenaKM} onChange={e=>setCijenaKM(e.target.value)} style={IS} placeholder="0"/>
        </FR>
        <button onClick={save} disabled={loading} style={{...BP,opacity:loading?0.7:1,marginBottom:10}}>{loading?"Sprema...":"💾 Spremi izmjene"}</button>
        <button onClick={async()=>{
          if(!window.confirm("Obrisati cijelu historiju za ovog korisnika? Ovo je nepovratno."))return;
          await onSave({...u,ime:ime.trim()||u.ime,telefon:telefon.trim(),cijenaKM:parseFloat(cijenaKM)||0,historija:[]});
        }} style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.red}44`,background:"#1f0d0d",color:C.red,fontSize:13,cursor:"pointer"}}>🗑️ Obriši historiju korisnika</button>
      </div>
    </div>
  );
}

function UserDetailModal({u,onClose,onExtend,onDelete,onUplata,onVivoToggle,onEdit}){
  const st=STATUS(u.expiry);const ps=PAY(u.payStatus);
  const ukupno=(u.historija||[]).filter(h=>h.payStatus==="placeno"&&h.cijenaKM>0).reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  const dug=(u.historija||[]).filter(h=>h.payStatus==="nije_placeno").reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  return(
    <Modal title={u.ime} onClose={onClose}>
      <div style={{display:"flex",gap:7,marginBottom:12,flexWrap:"wrap"}}>
        <span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:st.bg,color:st.color,border:`1px solid ${st.border}`,fontWeight:700}}>{st.label}</span>
        <span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:ps.bg,color:ps.color,fontWeight:700}}>{ps.label}</span>
        {u.vivo&&<span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:C.pdim,color:C.purple,fontWeight:700}}>Vivo</span>}
      </div>
      <div style={{display:"flex",gap:8,marginBottom:12}}>
        <div style={{flex:1,background:"#0d2318",border:"1px solid #166534",borderRadius:10,padding:"10px 12px",textAlign:"center"}}>
          <div style={{fontSize:10,color:C.muted,textTransform:"uppercase",letterSpacing:0.7,marginBottom:3}}>Ukupno uplaćeno</div>
          <div style={{fontSize:15,fontWeight:800,color:C.green}}>{fmtKM(ukupno)}</div>
        </div>
        {dug>0&&<div style={{flex:1,background:"#1f0d0d",border:"1px solid #7f1d1d",borderRadius:10,padding:"10px 12px",textAlign:"center"}}>
          <div style={{fontSize:10,color:C.muted,textTransform:"uppercase",letterSpacing:0.7,marginBottom:3}}>Duguje</div>
          <div style={{fontSize:15,fontWeight:800,color:C.red}}>{fmtKM(dug)}</div>
        </div>}
      </div>
      <div style={{background:C.bg,borderRadius:10,padding:"10px 14px",marginBottom:12}}>
        {[[u.telefon&&"📞 Telefon",u.telefon],["📅 Istek",fmtDate(u.expiry)],["📆 Dodan",fmtDate(u.kreiran)]].filter(([l])=>l).map(([l,v])=>(
          <div key={l} style={{display:"flex",justifyContent:"space-between",fontSize:13,padding:"6px 0",borderBottom:`1px solid ${C.border}`}}><span style={{color:C.muted}}>{l}</span><span style={{fontWeight:600}}>{v}</span></div>
        ))}
      </div>
      {u.historija?.length>0&&(
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.8,marginBottom:7}}>Historija</div>
          <div style={{maxHeight:140,overflowY:"auto"}}>
            {[...u.historija].reverse().map((h,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:12,padding:"6px 0",borderBottom:`1px solid ${C.border}`}}>
                <div><span style={{color:h.tip==="novi"?C.accent:h.tip==="import"?C.yellow:h.tip==="uplata"?"#fb923c":C.purple,fontWeight:600}}>{h.tip==="novi"?"Novi":h.tip==="import"?"Import":h.tip==="uplata"?"Uplata":"Prod."}</span> {h.mjeseci?`${h.mjeseci}mj · `:""}{PAY(h.payStatus).label} {h.cijenaKM>0?`· ${fmtKM(h.cijenaKM)}`:""}</div>
                <div style={{color:C.muted,whiteSpace:"nowrap",marginLeft:8}}>{h.datum}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{marginBottom:10}}>
        <button onClick={onEdit} style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,background:C.bg,color:C.text,fontSize:13,fontWeight:600,cursor:"pointer",textAlign:"left"}}>
          ✏️ Uredi podatke korisnika
        </button>
      </div>
      <div style={{marginBottom:10}}>
        <button onClick={onVivoToggle} style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${u.vivo?C.purple:C.border}`,background:u.vivo?`${C.purple}18`:C.bg,color:u.vivo?C.purple:C.muted,fontSize:13,fontWeight:600,cursor:"pointer",textAlign:"left"}}>
          {u.vivo?"✅ 📺 Vivo Player — klikni za uklanjanje":"⬜ 📺 Dodaj Vivo Player (+5 kredita)"}
        </button>
      </div>
      <div style={{display:"flex",gap:8,marginBottom:8}}>
        <button onClick={onUplata} style={{...BP,flex:1,background:"linear-gradient(135deg,#166534,#14532d)"}}>💳 Uplata</button>
        <button onClick={()=>genPDF(u)} style={{flex:1,padding:"13px",borderRadius:12,border:`1px solid #0c3d5a`,background:C.adim,color:C.accent,fontSize:14,fontWeight:700,cursor:"pointer"}}>🖨️ PDF</button>
      </div>
      <div style={{display:"flex",gap:10}}>
        <button onClick={onExtend} style={{...BP,flex:2}}>📅 Produži</button>
        <button onClick={onDelete} style={{flex:1,padding:"13px",borderRadius:12,border:`1px solid ${C.red}44`,background:"#1f0d0d",color:C.red,fontSize:15,cursor:"pointer"}}>🗑️</button>
      </div>
    </Modal>
  );
}

// ══ EXTEND MODAL ══════════════════════════════════════════
function ExtendModal({u,credits,onClose,onSave}){
  const [ukupno,setUkupno]=useState("1");
  const [placeno,setPlaceno]=useState("1");
  const [km,setKm]=useState("");
  const [splitMode,setSplitMode]=useState(false);

  const ukupnoN=parseInt(ukupno)||0;
  const placenoN=Math.min(parseInt(placeno)||0,ukupnoN);
  const gratisN=ukupnoN-placenoN;
  const dl=daysLeft(u.expiry);
  const ne=ukupnoN?(dl>=0?addMonths(u.expiry,ukupnoN):addMonths(today(),ukupnoN)):"";
  const enough=credits>=ukupnoN;

  const handleSave=()=>{
    if(!ukupnoN||!enough)return;
    onSave({ukupnoMj:ukupnoN,placenoMj:placenoN,gratisMj:gratisN,km:parseFloat(km||0),splitMode});
  };

  return(
    <Modal title={`Produži: ${u.ime}`} onClose={onClose}>
      <div style={{background:C.bg,borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:13}}>
        <div style={{color:C.muted}}>Istek: <span style={{color:C.text,fontWeight:600}}>{fmtDate(u.expiry)}</span></div>
        <div style={{color:C.muted,marginTop:3,fontSize:12}}>{dl>=0?"✅ Aktivan — dodaje se na kraj":"❌ Isteklo — od danas"}</div>
      </div>
      <FR label="Ukupno mjeseci">
        <input style={IS} type="number" min="1" value={ukupno} onChange={e=>{setUkupno(e.target.value);if(!splitMode)setPlaceno(e.target.value);}} inputMode="numeric"/>
      </FR>
      {/* Toggle split plaćeno/gratis */}
      <div style={{marginBottom:12}}>
        <button onClick={()=>{setSplitMode(v=>!v);if(!splitMode)setPlaceno(ukupno);else setPlaceno(ukupno);}} style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${splitMode?C.purple:C.border}`,background:splitMode?`${C.purple}18`:C.bg,color:splitMode?C.purple:C.muted,fontSize:12,fontWeight:600,cursor:"pointer",textAlign:"left"}}>
          {splitMode?"✅ Split mode — podijeljeno plaćeno/gratis":"⬜ Podijeli na plaćeno + gratis"}
        </button>
      </div>
      {splitMode&&(
        <div style={{background:"#1a0c2e",border:`1px solid ${C.purple}44`,borderRadius:12,padding:"12px 14px",marginBottom:12}}>
          <div style={{fontSize:12,color:C.purple,fontWeight:700,marginBottom:10}}>📊 Raspodjela {ukupnoN} mj</div>
          <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:8}}>
            <div style={{flex:1}}>
              <label style={{...LS,color:C.green}}>✅ Plaćeno (mj)</label>
              <input style={{...IS,borderColor:C.green}} type="number" min="0" max={ukupnoN} value={placeno} onChange={e=>setPlaceno(e.target.value)} inputMode="numeric"/>
            </div>
            <div style={{flex:1}}>
              <label style={{...LS,color:C.purple}}>🎁 Gratis (mj)</label>
              <input style={{...IS,borderColor:C.purple,background:"#1a0c2e"}} type="number" value={gratisN} readOnly/>
            </div>
          </div>
        </div>
      )}
      <FR label={`Cijena za plaćene mj. (KM)${!splitMode&&placenoN===0?" — sve gratis":""}`}>
        <input style={IS} type="number" min="0" step="0.5" value={km} onChange={e=>setKm(e.target.value)} placeholder="npr. 10.00" inputMode="decimal" disabled={placenoN===0}/>
      </FR>
      <div style={{background:C.adim,borderRadius:10,padding:"12px 14px",marginBottom:16,fontSize:13}}>
        {[
          ["Krediti",`${ukupnoN} kr`,enough?C.accent:C.red],
          ["Novi istek",ne?fmtDate(ne):"—",C.green],
          splitMode&&placenoN>0&&["✅ Plaćeno",`${placenoN} mj · ${fmtKM(km||0)}`,C.green],
          splitMode&&gratisN>0&&["🎁 Gratis",`${gratisN} mj`,C.purple],
          !splitMode&&["Cijena",fmtKM(km||0),C.green],
        ].filter(Boolean).map(([l,v,c])=>(
          <div key={l} style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><span style={{color:C.muted}}>{l}:</span><span style={{color:c,fontWeight:700}}>{v}</span></div>
        ))}
      </div>
      {!enough&&<div style={{color:C.red,fontSize:12,textAlign:"center",marginBottom:10}}>⚠️ Nedovoljno kredita ({credits} dostupno)!</div>}
      <button onClick={handleSave} disabled={!enough} style={{...BP,opacity:enough?1:0.4}}>Produži pretplatu</button>
    </Modal>
  );
}

// ══ PROMIJENI UPLATU MODAL ════════════════════════════════
function PromijeniUplatuModal({u,onClose,onSave}){
  const currentPay=u.payStatus;
  const [pay,setPay]=useState("placeno");
  const [km,setKm]=useState(u.cijenaKM||"");
  const opts=[{v:"placeno",l:"✅ Plaćeno",c:C.green},{v:"nije_placeno",l:"❌ Nije plaćeno",c:C.red},{v:"gratis",l:"🎁 Gratis",c:C.purple}].filter(o=>o.v!==currentPay);
  return(
    <Modal title="Promijeni status uplate" onClose={onClose}>
      <div style={{background:C.bg,borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13}}>
        <div style={{color:C.muted,marginBottom:6}}>Korisnik: <span style={{color:C.text,fontWeight:600}}>{u.ime}</span></div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:11,color:C.muted}}>Trenutno:</span>
          <span style={{fontSize:11,padding:"2px 9px",borderRadius:5,background:PAY(currentPay).bg,color:PAY(currentPay).color,fontWeight:700}}>{PAY(currentPay).label}</span>
        </div>
      </div>
      <div style={{marginBottom:16}}>
        <label style={LS}>Novi status</label>
        <div style={{display:"flex",gap:8}}>
          {opts.map(o=><button key={o.v} onClick={()=>setPay(o.v)} style={{flex:1,padding:"10px 6px",borderRadius:10,border:`1.5px solid ${pay===o.v?o.c:C.border}`,background:pay===o.v?`${o.c}18`:C.bg,color:pay===o.v?o.c:C.muted,fontSize:12,fontWeight:600,cursor:"pointer"}}>{o.l}</button>)}
        </div>
      </div>
      {pay!=="gratis"&&<div style={{marginBottom:16}}><label style={LS}>{`Cijena (KM)${pay==="nije_placeno"?" — dugovanje":""}`}</label><input style={{...IS,borderColor:pay==="nije_placeno"?C.red:C.border}} type="number" min="0" step="0.5" value={km} onChange={e=>setKm(e.target.value)} placeholder="npr. 10.00" inputMode="decimal"/></div>}
      <div style={{background:C.adim,borderRadius:10,padding:"11px 14px",marginBottom:16,fontSize:13}}>
        <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:C.muted}}>Novi status:</span><span style={{color:PAY(pay).color,fontWeight:700}}>{PAY(pay).label}</span></div>
        {pay!=="gratis"&&<div style={{display:"flex",justifyContent:"space-between",marginTop:5}}><span style={{color:C.muted}}>Cijena:</span><span style={{color:pay==="placeno"?C.green:C.red,fontWeight:700}}>{fmtKM(km||0)}</span></div>}
      </div>
      <button onClick={()=>onSave({pay,km:parseFloat(km||0)})} style={BP}>Potvrdi promjenu</button>
    </Modal>
  );
}

// ══ DUGOVANJA ════════════════════════════════════════════
function DugPage({users}){
  const mob=isMobile();
  const dug=users.filter(u=>u.payStatus==="nije_placeno");
  const total=dug.reduce((s,u)=>s+(parseFloat(u.cijenaKM)||0),0);
  const csvRows=[["Ime","Telefon","Istek","Status","Duguje KM"],...dug.map(u=>[u.ime,u.telefon||"",u.expiry,STATUS(u.expiry).label,u.cijenaKM||0])];
  return(
    <div style={{padding:mob?"16px":"0"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,paddingTop:mob?8:0}}>
        <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800}}>💸 Dugovanja</div>
        {!mob&&dug.length>0&&<CsvBtn label="Export CSV" rows={csvRows}/>}
      </div>
      {dug.length>0&&<div style={{background:"#1c0f00",border:`1px solid ${C.orange}44`,borderRadius:12,padding:"12px 18px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{fontSize:13,color:C.muted}}>Ukupno potraživanja:</div><div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800,color:C.orange}}>{fmtKM(total)}</div></div>}
      {dug.length===0?<div style={{textAlign:"center",padding:"50px",background:C.card,border:`1px solid ${C.border}`,borderRadius:14,color:C.muted}}><div style={{fontSize:40,marginBottom:12}}>🎉</div><div style={{fontWeight:700}}>Nema dugovanja!</div></div>:(
        mob?(
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {dug.map(u=>{const st=STATUS(u.expiry);return(
              <div key={u.id} style={{background:C.card,border:`1px solid ${C.red}33`,borderRadius:14,padding:"14px 16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><div style={{fontWeight:600,fontSize:15}}>{u.ime}</div><span style={{fontSize:14,fontWeight:800,color:C.red}}>{fmtKM(u.cijenaKM)}</span></div>
                <div style={{display:"flex",gap:7}}><span style={{fontSize:11,padding:"2px 8px",borderRadius:5,background:st.bg,color:st.color,border:`1px solid ${st.border}`,fontWeight:600}}>{st.label}</span><span style={{fontSize:11,color:C.muted}}>{fmtDate(u.expiry)}</span></div>
              </div>
            );})}
          </div>
        ):(
          <div style={{background:C.card,border:`1px solid ${C.red}33`,borderRadius:14,overflow:"hidden"}}>
            <div style={{display:"grid",gridTemplateColumns:"1.5fr 140px 120px 110px 110px",padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:11,color:C.muted,textTransform:"uppercase",letterSpacing:0.6}}>
              <span>Korisnik</span><span>Telefon</span><span>Istek</span><span>Status</span><span>Duguje</span>
            </div>
            {dug.map((u,i)=>{const st=STATUS(u.expiry);return(
              <div key={u.id} style={{display:"grid",gridTemplateColumns:"1.5fr 140px 120px 110px 110px",padding:"12px 18px",alignItems:"center",borderBottom:i<dug.length-1?`1px solid ${C.border}`:"none"}}>
                <span style={{fontWeight:500}}>{u.ime}</span><span style={{color:C.muted,fontSize:13}}>{u.telefon||"—"}</span><span style={{fontSize:13}}>{fmtDate(u.expiry)}</span>
                <span style={{fontSize:11,padding:"3px 9px",borderRadius:5,background:st.bg,color:st.color,border:`1px solid ${st.border}`,fontWeight:700,display:"inline-block"}}>{st.label}</span>
                <span style={{fontSize:14,fontWeight:700,color:C.red}}>{fmtKM(u.cijenaKM)}</span>
              </div>
            );})}
            <div style={{display:"flex",justifyContent:"flex-end",padding:"12px 18px",borderTop:`1px solid ${C.border}`,background:"#150c08"}}><span style={{fontSize:13,color:C.muted,marginRight:12}}>UKUPNO:</span><span style={{fontSize:16,fontWeight:800,color:C.orange}}>{fmtKM(total)}</span></div>
          </div>
        )
      )}
    </div>
  );
}

// ══ REKAPITULACIJA ═══════════════════════════════════
function RekapPage({users,crHist}){
  const mob=isMobile();
  const MJES=["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"];
  const [view,setView]=useState("godine"); // "godine" | "YYYY"

  // ── Čitamo SAMO validne finansijske zapise iz historije ──
  const validTips=["novi","produženje","produzenje","import"];
  const allH=users.flatMap(u=>(u.historija||[])
    .filter(h=>validTips.includes(h.tip)&&parseInt(h.mjeseci||0)>0)
    .map(h=>({...h,ime:u.ime}))
  );

  // Grupiranje po YYYY-MM
  const byMonth={};
  allH.forEach(h=>{
    const d=h.datum||"";
    if(!d)return;
    const ym=d.slice(0,7);
    if(!byMonth[ym])byMonth[ym]={naplaceno:0,dugovanje:0,gratisMj:0};
    const m=byMonth[ym];
    const mj=parseInt(h.mjeseci||0);
    if(h.payStatus==="placeno")           m.naplaceno+=parseFloat(h.cijenaKM||0);
    else if(h.payStatus==="nije_placeno") m.dugovanje+=parseFloat(h.cijenaKM||0);
    else if(h.payStatus==="gratis")       m.gratisMj+=mj;
  });
  // Trošak kredita po kupovini
  const krByMonth={};
  (crHist||[]).forEach(h=>{
    const d=h.datum||"";if(!d)return;
    const ym=d.slice(0,7);
    krByMonth[ym]=(krByMonth[ym]||0)+parseFloat(h.placenoKM||0);
  });

  // Sve godine
  const allYears=[...new Set([...Object.keys(byMonth),...Object.keys(krByMonth)].map(k=>k.slice(0,4)))].sort().reverse();

  // Agregiraj po godini
  const byYear={};
  [...Object.keys(byMonth),...Object.keys(krByMonth)].forEach(ym=>{
    const y=ym.slice(0,4);
    if(!byYear[y])byYear[y]={naplaceno:0,dugovanje:0,gratisMj:0,krTrosak:0};
    if(byMonth[ym]){
      byYear[y].naplaceno+=byMonth[ym].naplaceno;
      byYear[y].dugovanje+=byMonth[ym].dugovanje;
      byYear[y].gratisMj+=byMonth[ym].gratisMj;
    }
    if(krByMonth[ym]) byYear[y].krTrosak+=krByMonth[ym];
  });

  // Ukupno
  const ukupno={
    naplaceno:Object.values(byYear).reduce((s,y)=>s+y.naplaceno,0),
    dugovanje:Object.values(byYear).reduce((s,y)=>s+y.dugovanje,0),
    gratisMj:Object.values(byYear).reduce((s,y)=>s+y.gratisMj,0),
    krTrosak:Object.values(byYear).reduce((s,y)=>s+y.krTrosak,0),
  };
  ukupno.profit=ukupno.naplaceno-ukupno.krTrosak;
  // gratisMj je samo informativan

  // CSV
  const csvRows=[["Period","Naplaćeno KM","Dugovanje KM","Gratis mj","Gratis trošak KM","Trošak kredita KM","Profit KM"]];
  if(view==="godine"){
    allYears.forEach(y=>{
      const d=byYear[y]||{};
      csvRows.push([y,fmtKM(d.naplaceno||0),fmtKM(d.dugovanje||0),d.gratisMj||0,fmtKM(d.gratisKost||0),fmtKM(d.krTrosak||0),fmtKM((d.naplaceno||0)-(d.krTrosak||0))]);
    });
  }else{
    Array.from({length:12},(_,i)=>{
      const ym=`${view}-${String(i+1).padStart(2,"0")}`;
      const d=byMonth[ym]||{};const kr=krByMonth[ym]||0;
      csvRows.push([`${MJES[i]} ${view}`,fmtKM(d.naplaceno||0),fmtKM(d.dugovanje||0),d.gratisMj||0,fmtKM(d.gratisKost||0),fmtKM(kr),fmtKM((d.naplaceno||0)-kr)]);
    });
  }

  // ── Komponente ──
  const StatTop=({label,value,color,bg,icon})=>(
    <div style={{background:bg||C.card,border:`1px solid ${color}33`,borderRadius:12,padding:mob?"10px 12px":"12px 16px",textAlign:"center"}}>
      <div style={{fontSize:mob?18:22,marginBottom:3}}>{icon}</div>
      <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?15:18,fontWeight:800,color}}>{value}</div>
      <div style={{fontSize:mob?9:10,color:C.muted,marginTop:2,textTransform:"uppercase",letterSpacing:0.5}}>{label}</div>
    </div>
  );

  const RowCard=({period,d,kr,isYear,onClick})=>{
    const profit=(d.naplaceno||0)-(kr||0);
    return(
      <div onClick={onClick} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"14px 16px",marginBottom:8,cursor:onClick?"pointer":"default",transition:"border-color 0.2s"}}
        onMouseEnter={e=>{if(onClick)e.currentTarget.style.borderColor=C.accent;}}
        onMouseLeave={e=>{if(onClick)e.currentTarget.style.borderColor=C.border;}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div style={{fontWeight:700,fontSize:15,display:"flex",alignItems:"center",gap:6}}>
            {period}{isYear&&<span style={{fontSize:11,color:C.muted}}>→ klikni za detalje</span>}
          </div>
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:16,fontWeight:800,color:profit>=0?C.accent:C.red}}>{fmtKM(profit)}</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:12}}>
          {[
            ["💰 Naplaćeno",fmtKM(d.naplaceno||0),C.green],
            ["💸 Trošak kr.",fmtKM(kr||0),C.red],
            (d.dugovanje||0)>0&&["📋 Dugovanje",fmtKM(d.dugovanje),C.orange],
            (d.gratisMj||0)>0&&["🎁 Gratis",`${d.gratisMj} mj`,C.purple],
          ].filter(Boolean).map(([l,v,c])=>(
            <div key={l} style={{background:C.bg,borderRadius:8,padding:"7px 10px"}}>
              <div style={{color:C.muted,fontSize:10,marginBottom:2}}>{l}</div>
              <div style={{fontWeight:700,color:c}}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const RowDesktop=({period,d,kr,bold,onClick})=>{
    const profit=(d.naplaceno||0)-(kr||0);
    return(
      <div onClick={onClick} style={{display:"grid",gridTemplateColumns:"130px 1fr 1fr 1fr 1fr 1fr",padding:"11px 18px",alignItems:"center",borderBottom:`1px solid ${C.border}`,background:bold?"#0c1020":C.card,cursor:onClick?"pointer":"default",fontWeight:bold?700:400}}
        onMouseEnter={e=>{if(onClick)e.currentTarget.style.background="#0c2034";}}
        onMouseLeave={e=>{if(onClick)e.currentTarget.style.background=bold?"#0c1020":C.card;}}>
        <span style={{color:bold?C.text:C.accent,fontWeight:bold?700:600,fontSize:13}}>{period}{onClick&&<span style={{fontSize:10,color:C.muted,marginLeft:4}}>↗</span>}</span>
        <span style={{color:C.green,fontWeight:600}}>{fmtKM(d.naplaceno||0)}</span>
        <span style={{color:C.red}}>{fmtKM(kr||0)}</span>
        <span style={{color:profit>=0?C.accent:C.red,fontWeight:700}}>{fmtKM(profit)}</span>
        <span style={{color:C.orange}}>{(d.dugovanje||0)>0?fmtKM(d.dugovanje):"—"}</span>
        <span style={{color:C.purple}}>{(d.gratisMj||0)>0?`${d.gratisMj} mj`:"—"}</span>
      </div>
    );
  };

  return(
    <div style={{padding:mob?"16px":"0"}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,paddingTop:mob?8:0,flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          {view!=="godine"&&<button onClick={()=>setView("godine")} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13,padding:"4px 8px",borderRadius:6,border:`1px solid ${C.border}`}}>← Natrag</button>}
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?18:22,fontWeight:800}}>
            📋 {view==="godine"?"Rekapitulacija":view}
          </div>
        </div>
        <CsvBtn label="Export CSV" rows={csvRows}/>
      </div>

      {/* Top stats — ukupno sve */}
      <div style={{display:"grid",gridTemplateColumns:mob?"repeat(2,1fr)":"repeat(4,1fr)",gap:mob?8:12,marginBottom:16}}>
        <StatTop label="Ukupno naplaćeno" value={fmtKM(ukupno.naplaceno)} color={C.green}  bg="#0d2318" icon="💰"/>
        <StatTop label="Trošak kredita"   value={fmtKM(ukupno.krTrosak)}  color={C.red}    bg="#1f0d0d" icon="💳"/>
        <StatTop label="Profit"           value={fmtKM(ukupno.profit)}    color={ukupno.profit>=0?C.accent:C.red} bg={C.adim} icon="📈"/>
        <StatTop label="Gratis mj."       value={`${ukupno.gratisMj||0} mj`} color={C.purple} bg={C.pdim} icon="🎁"/>
      </div>

      {/* Prikaz */}
      {mob?(
        // ── MOBILE ──
        view==="godine"?(
          allYears.length===0
            ?<div style={{textAlign:"center",padding:40,color:C.muted}}>Nema podataka</div>
            :allYears.map(y=><RowCard key={y} period={y} d={byYear[y]||{}} kr={byYear[y]?.krTrosak||0} isYear onClick={()=>setView(y)}/>)
        ):(
          Array.from({length:12},(_,i)=>{
            const ym=`${view}-${String(i+1).padStart(2,"0")}`;
            const d=byMonth[ym]||{};const kr=krByMonth[ym]||0;
            if(!d.naplaceno&&!d.gratisMj&&!kr&&!d.dugovanje)return null;
            return<RowCard key={ym} period={`${MJES[i]} ${view}`} d={d} kr={kr}/>;
          })
        )
      ):(
        // ── DESKTOP ──
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"130px 1fr 1fr 1fr 1fr 1fr",padding:"10px 18px",borderBottom:`1px solid ${C.border}`,fontSize:10,color:C.muted,textTransform:"uppercase",letterSpacing:0.6}}>
            <span>Period</span><span>Naplaćeno</span><span>Trošak kr.</span><span>Profit</span><span>Dugovanje</span><span>Gratis mj.</span>
          </div>
          {view==="godine"?(
            allYears.length===0
              ?<div style={{textAlign:"center",padding:40,color:C.muted}}>Nema podataka</div>
              :allYears.map(y=><RowDesktop key={y} period={y} d={byYear[y]||{}} kr={byYear[y]?.krTrosak||0} onClick={()=>setView(y)}/>)
          ):(
            Array.from({length:12},(_,i)=>{
              const ym=`${view}-${String(i+1).padStart(2,"0")}`;
              const d=byMonth[ym]||{};const kr=krByMonth[ym]||0;
              if(!d.naplaceno&&!d.gratisMj&&!kr&&!d.dugovanje)return null;
              return<RowDesktop key={ym} period={`${MJES[i]} ${view}`} d={d} kr={kr}/>;
            })
          )}
          {/* Totali */}
          <div style={{display:"grid",gridTemplateColumns:"130px 1fr 1fr 1fr 1fr 1fr",padding:"12px 18px",borderTop:`2px solid ${C.border}`,background:"#0c1020",fontWeight:700,fontSize:13}}>
            <span style={{color:C.muted}}>UKUPNO</span>
            <span style={{color:C.green}}>{fmtKM(ukupno.naplaceno)}</span>
            <span style={{color:C.red}}>{fmtKM(ukupno.krTrosak)}</span>
            <span style={{color:ukupno.profit>=0?C.accent:C.red}}>{fmtKM(ukupno.profit)}</span>
            <span style={{color:C.orange}}>{ukupno.dugovanje>0?fmtKM(ukupno.dugovanje):"—"}</span>
            <span style={{color:C.purple}}>{ukupno.gratisMj>0?`${ukupno.gratisMj} mj`:"—"}</span>
          </div>
        </div>
      )}
    </div>
  );
}

// ══ KREDITI ══════════════════════════════════════════════
function KrediPage({credits,saveCredits,crHist,saveCrHist,showToast,users}){
  const mob=isMobile();
  const [f,sf]=useState({kol:"",km:"",datum:today()});
  const F=(k,v)=>sf(p=>({...p,[k]:v}));
  const totPlac=crHist.reduce((s,h)=>s+(parseFloat(h.placenoKM)||0),0);
  const zarada=users.flatMap(u=>u.historija||[]).filter(h=>h.payStatus==="placeno").reduce((s,h)=>s+(parseFloat(h.cijenaKM)||0),0);
  const profit=zarada-totPlac;
  const add=async()=>{
    const n=parseInt(f.kol);if(!n||n<=0){showToast("Unesite broj kredita","err");return;}
    const entry={datum:f.datum,kolicina:n,placenoKM:parseFloat(f.km||0)};
    const nh=[entry,...crHist];
    await saveCrHist(nh);await saveCredits(credits+n);
    showToast(`✅ Dodano ${n} kredita!`);sf({kol:"",km:"",datum:today()});
  };
  return(
    <div style={{padding:mob?"16px":"0"}}>
      <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800,marginBottom:16,paddingTop:mob?8:0}}>💳 Krediti</div>
      <div style={{display:"grid",gridTemplateColumns:mob?"1fr 1fr":"repeat(4,1fr)",gap:mob?10:14,marginBottom:20}}>
        <Stat label="Dostupni"   value={credits}        icon="💳" color={C.accent}                  bg={C.adim}  small={mob}/>
        <Stat label="Za kredite" value={fmtKM(totPlac)} icon="💸" color={C.red}                     bg="#1f0d0d" small={mob}/>
        <Stat label="Naplaćeno"  value={fmtKM(zarada)}  icon="💰" color={C.green}                   bg="#0d2318" small={mob}/>
        <Stat label="Profit"     value={fmtKM(profit)}  icon={profit>=0?"📈":"📉"} color={profit>=0?C.accent:C.red} bg={profit>=0?C.adim:"#1f0d0d"} small={mob}/>
      </div>
      <div style={{display:mob?"block":"grid",gridTemplateColumns:"1fr 1.5fr",gap:22}}>
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:mob?16:22,marginBottom:mob?14:0}}>
          <div style={{fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14,marginBottom:14}}>➕ Dodaj kredite</div>
          <FR label="Broj kredita"><input style={IS} type="number" min="1" placeholder="npr. 50" value={f.kol} onChange={e=>F("kol",e.target.value)} inputMode="numeric"/></FR>
          <FR label="Plaćeno (KM)"><input style={IS} type="number" min="0" step="0.5" placeholder="npr. 25.00" value={f.km} onChange={e=>F("km",e.target.value)} inputMode="decimal"/></FR>
          <FR label="Datum"><input style={IS} type="date" value={f.datum} onChange={e=>F("datum",e.target.value)}/></FR>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
            {[10,25,50,100].map(n=><button key={n} onClick={()=>F("kol",String(n))} style={{padding:"10px 0",borderRadius:10,border:`1px solid ${C.border}`,background:f.kol===String(n)?C.adim:C.bg,color:f.kol===String(n)?C.accent:C.muted,cursor:"pointer",fontSize:13,fontWeight:600}}>+{n}</button>)}
          </div>
          {f.kol&&f.km&&<div style={{background:C.adim,borderRadius:8,padding:"9px 13px",marginBottom:14,fontSize:13,display:"flex",justifyContent:"space-between"}}><span style={{color:C.muted}}>Cijena/kredit:</span><span style={{color:C.accent,fontWeight:700}}>{fmtKM(parseFloat(f.km)/parseInt(f.kol))}</span></div>}
          <button onClick={add} style={BP}>Dodaj kredite</button>
        </div>
        <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
          <div style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`,fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:14}}>📜 Historija kupovina</div>
          {crHist.length===0?<div style={{padding:28,textAlign:"center",color:C.muted,fontSize:13}}>Nema historije</div>:crHist.map((h,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"12px 18px",borderBottom:i<crHist.length-1?`1px solid ${C.border}`:"none",fontSize:13,alignItems:"center"}}>
              <div><div style={{color:C.accent,fontWeight:700}}>+{h.kolicina} kredita</div><div style={{fontSize:11,color:C.muted,marginTop:2}}>{fmtDate(h.datum)}</div></div>
              <div style={{textAlign:"right"}}><div style={{color:C.red,fontWeight:600}}>{fmtKM(h.placenoKM)}</div><div style={{fontSize:11,color:C.muted,marginTop:2}}>{h.kolicina?fmtKM(parseFloat(h.placenoKM||0)/parseInt(h.kolicina)):""}/kr</div></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ══ IMPORT ═══════════════════════════════════════════════
function ImportPage({users,saveUser,credits,saveCredits,showToast,setPage}){
  const mob=isMobile();
  const [preview,setPreview]=useState(null);
  const [dupMode,setDupMode]=useState("skip");
  const fileRef=useRef();
  const parseCSV=text=>{const lines=text.trim().split(/\r?\n/);const sep=lines[0].includes(";")?";":",";const headers=lines[0].split(sep).map(h=>h.replace(/^["']|["']$/g,"").trim());return lines.slice(1).map(line=>{const vals=line.split(sep).map(v=>v.replace(/^["']|["']$/g,"").trim());const obj={};headers.forEach((h,i)=>obj[h]=vals[i]||"");return obj;}).filter(r=>Object.values(r).some(v=>v));};
  const processRows=rows=>rows.map(r=>{const ime=(r["Pretplatnik"]||r["Ime"]||r["ime"]||Object.values(r)[0]||"").trim();const tel=(r["Telefon"]||r["telefon"]||"").trim();const mj=parseInt(r["Trajanje (mjeseci)"]||r["Trajanje"]||r["Mjeseci"]||Object.values(r)[2]||"1")||1;const startRaw=r["Pretplata početak"]||r["Datum početka"]||Object.values(r)[1]||"";let start=today();if(startRaw){const d=new Date(startRaw);if(!isNaN(d))start=d.toISOString().split("T")[0];}const expiry=addMonths(start,mj);const km=parseFloat(String(r["Uplata KM"]||r["Cijena"]||"0").replace(",","."))||0;return{ime,tel,mj,expiry,pay:km>0?"placeno":"gratis",km};}).filter(r=>r.ime.length>1);
  const handleFile=async file=>{const text=await file.text();const proc=processRows(parseCSV(text));if(!proc.length){showToast("Nema podataka u fajlu","err");return;}setPreview(proc);showToast(`📋 Učitano ${proc.length} redova`);};
  const doImport=async()=>{let added=0,skipped=0,updated=0,cost=0;for(const r of preview){const exists=users.find(u=>u.ime.toLowerCase()===r.ime.toLowerCase());const entry={datum:today(),tip:"import",mjeseci:r.mj,payStatus:r.pay,cijenaKM:r.km,krediti:r.mj};if(exists){if(dupMode==="update"){await saveUser({...exists,expiry:r.expiry,payStatus:r.pay,cijenaKM:r.km,historija:[...(exists.historija||[]),entry]});cost+=r.mj;updated++;}else skipped++;}else{await saveUser({id:uid(),ime:r.ime,telefon:r.tel||"",expiry:r.expiry,payStatus:r.pay,cijenaKM:r.km,vivo:false,kreiran:today(),historija:[entry]});cost+=r.mj;added++;}}await saveCredits(Math.max(0,credits-cost));showToast(`✅ ${added} dodano, ${updated} ažurirano, ${skipped} preskočeno`);setPreview(null);setPage("korisnici");};
  const dups=preview?preview.filter(r=>users.some(u=>u.ime.toLowerCase()===r.ime.toLowerCase())):[];
  return(
    <div style={{padding:mob?"16px":"0",maxWidth:mob?"100%":720}}>
      <div style={{fontFamily:"'Syne',sans-serif",fontSize:mob?20:24,fontWeight:800,marginBottom:14,paddingTop:mob?8:0}}>📥 Import CSV</div>
      <div style={{background:C.adim,border:`1px solid #0c3d5a`,borderRadius:12,padding:"12px 16px",marginBottom:16,fontSize:12}}>
        <div style={{color:C.accent,fontWeight:700,marginBottom:5}}>📋 Kolone:</div>
        <div style={{color:C.muted,lineHeight:1.8}}>Pretplatnik · Pretplata početak · Trajanje (mjeseci) · Uplata KM</div>
      </div>
      {!preview&&(<div onClick={()=>fileRef.current.click()} style={{border:`2px dashed ${C.border}`,borderRadius:16,padding:"36px 20px",textAlign:"center",background:C.card,cursor:"pointer",marginBottom:10}}><div style={{fontSize:36,marginBottom:8}}>📂</div><div style={{fontWeight:600,fontSize:15,marginBottom:4}}>Odaberi CSV fajl</div><div style={{color:C.muted,fontSize:13}}>Klikni ovdje</div><input ref={fileRef} type="file" accept=".csv" onChange={e=>handleFile(e.target.files[0])} style={{display:"none"}}/></div>)}
      {preview&&(<>
        {dups.length>0&&<div style={{background:"#1c1300",border:`1px solid ${C.yellow}44`,borderRadius:10,padding:"12px 14px",marginBottom:12}}><div style={{fontSize:12,color:C.yellow,fontWeight:700,marginBottom:8}}>⚠️ {dups.length} duplikata</div><div style={{display:"flex",gap:8}}>{[["skip","⏭️ Preskoči"],["update","🔄 Ažuriraj"]].map(([v,l])=><button key={v} onClick={()=>setDupMode(v)} style={{flex:1,padding:"9px",borderRadius:9,border:`1.5px solid ${dupMode===v?C.yellow:C.border}`,background:dupMode===v?"#1c1300":C.bg,color:dupMode===v?C.yellow:C.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>{l}</button>)}</div></div>}
        <div style={{display:"flex",flexDirection:"column",gap:6,maxHeight:320,overflowY:"auto",marginBottom:12}}>
          {preview.map((r,i)=>{const dup=users.some(u=>u.ime.toLowerCase()===r.ime.toLowerCase());const ps=PAY(r.pay);const st=STATUS(r.expiry);return(<div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:"11px 14px",opacity:dup&&dupMode==="skip"?0.5:1}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><div style={{fontWeight:600,fontSize:13}}>{r.ime}{dup&&<span style={{fontSize:10,color:C.yellow,background:"#1c1300",padding:"1px 6px",borderRadius:4,marginLeft:6,fontWeight:700}}>duplikat</span>}</div><span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:st.bg,color:st.color,fontWeight:600}}>{st.label}</span></div><div style={{display:"flex",gap:8,fontSize:11,color:C.muted}}><span>{r.mj}mj</span><span>{fmtDate(r.expiry)}</span><span style={{color:ps.color,fontWeight:600}}>{ps.label}</span>{r.pay!=="gratis"&&<span style={{color:C.green}}>{fmtKM(r.km)}</span>}</div></div>);})}
        </div>
        <div style={{background:C.adim,borderRadius:10,padding:"10px 14px",marginBottom:12,fontSize:13,display:"flex",gap:20}}><div><span style={{color:C.muted}}>Redova: </span><span style={{fontWeight:700}}>{preview.length}</span></div><div><span style={{color:C.muted}}>Trošak: </span><span style={{color:C.accent,fontWeight:700}}>{preview.reduce((s,r)=>s+r.mj,0)} kr</span></div></div>
        <button onClick={doImport} style={{...BP,marginBottom:8}}>✅ Potvrdi import ({preview.length})</button>
        <button onClick={()=>setPreview(null)} style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:14,cursor:"pointer"}}>Otkaži</button>
      </>)}
    </div>
  );
}

// ══ MORE (mobile only) ════════════════════════════════════
function MorePage({setPage,user}){
  return(
    <div style={{padding:"16px"}}>
      <div style={{fontFamily:"'Syne',sans-serif",fontSize:20,fontWeight:800,marginBottom:18,paddingTop:8}}>⋯ Više</div>
      {[{icon:"📋",label:"Rekapitulacija",sub:"Historija transakcija",page:"rekap"},{icon:"💳",label:"Krediti",sub:"Dodaj i prati kredite",page:"krediti"},{icon:"📥",label:"Import CSV",sub:"Uvezi korisnike iz Excela",page:"import"}].map(m=>(
        <button key={m.page} onClick={()=>setPage(m.page)} style={{width:"100%",display:"flex",alignItems:"center",gap:14,background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:"16px",marginBottom:10,textAlign:"left",cursor:"pointer"}}>
          <div style={{fontSize:24,width:36,textAlign:"center"}}>{m.icon}</div>
          <div style={{flex:1}}><div style={{fontWeight:600,fontSize:15}}>{m.label}</div><div style={{fontSize:12,color:C.muted,marginTop:2}}>{m.sub}</div></div>
          <div style={{color:C.muted,fontSize:20}}>›</div>
        </button>
      ))}
      <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginTop:6}}>
        <div style={{fontSize:12,color:C.muted,marginBottom:10}}>{user?.email}</div>
        <button onClick={()=>signOut(auth)} style={{width:"100%",padding:"12px",borderRadius:12,border:`1px solid ${C.border}`,background:"transparent",color:C.muted,fontSize:14,cursor:"pointer"}}>🚪 Odjavi se</button>
      </div>
    </div>
  );
}
